export const NAICS = [
  {
    code: '11',
    title: 'Agriculture, forestry, fishing and hunting',
    description:
      'This sector comprises establishments primarily engaged in growing crops, raising animals, harvesting timber, harvesting fish and other animals from their natural habitats and providing related support activities. Establishments primarily engaged in agricultural research or that supply veterinary services are not included in this sector.',
  },
  {
    code: '21',
    title: 'Mining, quarrying, and oil and gas extraction',
    description:
      'This sector comprises establishments primarily engaged in extracting naturally occurring minerals. These can be solids, such as coal and ores; liquids, such as crude petroleum; and gases, such as natural gas. The term mining is used in the broad sense to include quarrying, well operations, milling (for example, crushing, screening, washing, or flotation) and other preparation customarily done at the mine site, or as a part of mining activity. Establishments engaged in exploration for minerals, development of mineral properties and mining operations are included in this sector. Establishments performing similar activities, on a contract or fee basis, are also included.',
  },
  {
    code: '22',
    title: 'Utilities',
    description:
      'This sector comprises establishments primarily engaged in operating electric, gas and water utilities. These establishments generate, transmit, control and distribute electric power; distribute natural gas; treat and distribute water; operate sewer systems and sewage treatment facilities; and provide related services, generally through a permanent infrastructure of lines, pipes and treatment and processing facilities.',
  },
  {
    code: '23',
    title: 'Construction',
    description:
      "This sector comprises establishments primarily engaged in constructing, repairing and renovating buildings and engineering works, and in subdividing and developing land. These establishments may operate on their own account or under contract to other establishments or property owners. They may produce complete projects or just parts of projects. Establishments often subcontract some or all of the work involved in a project, or work together in joint ventures. Establishments may produce new construction, or undertake repairs and renovations to existing structures. A construction establishment may be the only establishment of an enterprise, or one of several establishments of an integrated real estate enterprise engaged in the land assembly, development, financing, building and sale of large projects. There are substantial differences in the types of equipment, work force skills, and other inputs required by establishments in this sector. To highlight these differences and variations in the underlying production functions, this sector is divided into three subsectors. Establishments are distinguished initially between those that undertake projects that require several different construction activities (known as trades) to be performed, and establishments that specialize in one trade. The former are classified in subsectors 236 Construction of buildings and 237 Heavy and civil engineering construction, depending upon whether they are primarily engaged in the construction of buildings or in heavy construction and civil engineering projects. Establishments in these subsectors complete projects using their own labour force, by subcontracting, usually to trade contractors, or a combination of own account and subcontracting activities. Establishments classified in these subsectors are known by a variety of designations, such as general contractor, design-builder, speculative builder, operative builder and construction manager. The designation depends on the scope of the projects they undertake, the degree of responsibility and risk that they assume, the type of structure that they produce, and whether they work on contract for an owner or on their own account. General contractors typically work under contract to a client (the owner of the land and the building or structure to be constructed), and undertake projects that require several specialized construction activities to be performed. Often the general contractor will subcontract some of the specialized tasks to other establishments. Design-builders are similar to general contractors. However, in a design-build project a single contract is signed with the owner that makes the contractor responsible for providing the architectural and engineering designs. The design-builder therefore is responsible for the design of the project as well as its construction. Construction establishments that build on their own account, for sale to others, are known as speculative builders, operative builders or merchant builders. They are most often engaged in the construction of residential buildings. Construction managers provide oversight and scheduling services to the owner, for the most part during the actual construction process. This type of service is sometimes referred to as agency construction management, to distinguish it from a type of general contracting known as at-risk construction management. On the other hand, project management, which is a turnkey-type service involving the entire project, including feasibility studies, the arranging of financing, and the management of the contract bidding and selection process, is classified in 54133 Engineering services when it is the primary activity of an establishment. Establishments that specialize in one particular construction activity, or trade, are generally classified in subsector 238 Specialty trade contractors. However, in order to conform to the generally accepted distinctions made by construction businesses themselves, some types of specialized establishments involved in road building and civil engineering are classified in subsector 237 Heavy and civil engineering construction. Subsector 238, Specialty trade contractors, comprises establishments engaged in trade activities generally needed in the construction of buildings and structures, such as masonry, painting, or electrical work. Specialty trade contractors usually work under contract to another construction establishment but, especially in renovation and repair construction, they may contract directly with the owner of the property. A significant amount of construction work is performed by enterprises that are primarily engaged in some business other than construction, for these enterprises' own use, using employees and equipment of the enterprise. This activity is not included in the construction sector unless the construction work performed is the primary activity of a separate establishment of the enterprise. However, if separate establishments do exist, they are classified in the construction sector.",
  },
  {
    code: '31',
    title: 'Manufacturing',
    description:
      "This sector comprises establishments primarily engaged in the chemical, mechanical or physical transformation of materials or substances into new products. These products may be finished, in the sense that they are ready to be used or consumed, or semi-finished, in the sense of becoming a raw material for an establishment to use in further manufacturing. Related activities, such as the assembly of the component parts of manufactured goods; the blending of materials; and the finishing of manufactured products by dyeing, heat-treating, plating and similar operations are also treated as manufacturing activities. Manufacturing establishments are known by a variety of trade designations, such as plants, factories or mills. Manufacturing establishments may own the materials which they transform or they may transform materials owned by other establishments. Manufacturing may take place in factories or in workers' homes, using either machinery or hand tools. Units that completely outsource the transformation process but own the input materials are classified to the manufacturing sector. Units that completely outsource the transformation process but do not own the materials are classified to merchant wholesalers in Sector 41 Wholesale trade. These units are in fact buying the completed goods from the producer with the intention to resell it. These units may design the goods being manufactured, and may have some say in the manufacturing process. Certain activities involving the transformation of goods are classified in other sectors. Some examples are post-harvest activities of agricultural establishments, such as crop drying; logging; the beneficiating of mineral ores; the production of structures by construction establishments; and various activities conducted by retailers, such as meat cutting and the assembly of products such as bicycles and computers. Sales branches or offices (but not retail stores) maintained by manufacturing, refining, or mining enterprises apart from their plants or mines for the purpose of marketing their products are included in Sector 41 Wholesale trade as merchant wholesalers.",
  },
  {
    code: '32',
    title: 'Manufacturing',
    description:
      "This sector comprises establishments primarily engaged in the chemical, mechanical or physical transformation of materials or substances into new products. These products may be finished, in the sense that they are ready to be used or consumed, or semi-finished, in the sense of becoming a raw material for an establishment to use in further manufacturing. Related activities, such as the assembly of the component parts of manufactured goods; the blending of materials; and the finishing of manufactured products by dyeing, heat-treating, plating and similar operations are also treated as manufacturing activities. Manufacturing establishments are known by a variety of trade designations, such as plants, factories or mills. Manufacturing establishments may own the materials which they transform or they may transform materials owned by other establishments. Manufacturing may take place in factories or in workers' homes, using either machinery or hand tools. Units that completely outsource the transformation process but own the input materials are classified to the manufacturing sector. Units that completely outsource the transformation process but do not own the materials are classified to merchant wholesalers in Sector 41 Wholesale trade. These units are in fact buying the completed goods from the producer with the intention to resell it. These units may design the goods being manufactured, and may have some say in the manufacturing process. Certain activities involving the transformation of goods are classified in other sectors. Some examples are post-harvest activities of agricultural establishments, such as crop drying; logging; the beneficiating of mineral ores; the production of structures by construction establishments; and various activities conducted by retailers, such as meat cutting and the assembly of products such as bicycles and computers. Sales branches or offices (but not retail stores) maintained by manufacturing, refining, or mining enterprises apart from their plants or mines for the purpose of marketing their products are included in Sector 41 Wholesale trade as merchant wholesalers.",
  },
  {
    code: '33',
    title: 'Manufacturing',
    description:
      "This sector comprises establishments primarily engaged in the chemical, mechanical or physical transformation of materials or substances into new products. These products may be finished, in the sense that they are ready to be used or consumed, or semi-finished, in the sense of becoming a raw material for an establishment to use in further manufacturing. Related activities, such as the assembly of the component parts of manufactured goods; the blending of materials; and the finishing of manufactured products by dyeing, heat-treating, plating and similar operations are also treated as manufacturing activities. Manufacturing establishments are known by a variety of trade designations, such as plants, factories or mills. Manufacturing establishments may own the materials which they transform or they may transform materials owned by other establishments. Manufacturing may take place in factories or in workers' homes, using either machinery or hand tools. Units that completely outsource the transformation process but own the input materials are classified to the manufacturing sector. Units that completely outsource the transformation process but do not own the materials are classified to merchant wholesalers in Sector 41 Wholesale trade. These units are in fact buying the completed goods from the producer with the intention to resell it. These units may design the goods being manufactured, and may have some say in the manufacturing process. Certain activities involving the transformation of goods are classified in other sectors. Some examples are post-harvest activities of agricultural establishments, such as crop drying; logging; the beneficiating of mineral ores; the production of structures by construction establishments; and various activities conducted by retailers, such as meat cutting and the assembly of products such as bicycles and computers. Sales branches or offices (but not retail stores) maintained by manufacturing, refining, or mining enterprises apart from their plants or mines for the purpose of marketing their products are included in Sector 41 Wholesale trade as merchant wholesalers.",
  },
  {
    code: '41',
    title: 'Wholesale trade',
    description:
      "This sector comprises establishments primarily engaged in wholesaling merchandise, generally without transformation, and rendering services incidental to the sale of merchandise. The wholesaling process is an intermediate step in the distribution of goods. Many wholesalers are organized to sell merchandise in large quantities to retailers, and business and institutional clients. However, some wholesalers, in particular those that supply non-consumer capital goods, sell merchandise in single units to final users. Sales of capital goods or durable non-consumer goods used in the production of goods and services, such as farm machinery and equipment, heavy duty trucks, and industrial machinery, are always included in wholesale trade. Wholesalers sell merchandise to other businesses and normally operate from a warehouse or office. These warehouses and offices are characterized by having little or no display of merchandise. In addition, neither the design nor the location of the premises is intended to solicit walk-in traffic. Wholesalers do not normally use advertising directed to the general public. Customers are generally reached initially via telephone, in-person marketing, or by specialized advertising that may include Internet and other electronic means. Follow-up are either vendor-initiated or client initiated, generally based on previous sales, and typically exhibit strong ties between sellers and buyers. This sector comprises two main types of wholesalers: merchant wholesalers that sell goods on own account and wholesale electronic markets, agents, and brokers that arrange sales and purchases for others generally for a commission or fee. Merchants wholesalers Merchant wholesalers buy and sell merchandise on their own account, that is, they take title to the goods they sell. They generally operate from warehouse or office locations and they may ship from their own inventory or arrange for the shipment of goods directly from the supplier to the client. In addition to the sale of goods, they may provide, or arrange for the provision of, logistics, marketing and support services, such as packaging and labelling, inventory management, shipping, handling of warranty claims, in-store or co-op promotions, and product training. Merchants wholesalers are known by a variety of trade designations depending on their relationship with suppliers or customers, or the distribution method they employ. Examples include wholesale merchants, wholesale distributors, drop shippers, rack-jobbers, import-export merchants, and banner wholesalers. Included as merchant wholesalers are sales branches or offices (but not retail stores) maintained by manufacturing, refining, or mining enterprises apart from their plants or mines for the purpose of marketing their products. Merchant wholesalers also include units that completely outsource the transformation process but do not own the input materials. These units are in fact buying the completed good from the producer with the intention to resell it. These units may design the goods being manufactured, and may have some say in the manufacturing process. On the other hand, units that completely outsource the transformation process but own the inputs are classified to the manufacturing sector. The first eight subsectors of wholesale trade comprise merchant wholesalers. The grouping of these establishments into industry groups and industries is based on the merchandise line or lines supplied by the wholesaler. Business-to business electronic markets, and agents and brokers Business-to business electronic markets, and wholesale trade agents and brokers arrange for the purchase or sale of goods owned by others, generally for a commission or fee. They are known as business-to-business (B2B) electronic markets, wholesale trade agents and brokers, commission merchants, import-export agents and brokers, auction companies, and manufacturer's representatives. These establishments operate from offices and generally do not own or handle the goods they sell.",
  },
  {
    code: '44',
    title: 'Retail trade',
    description:
      'This sector comprises establishments primarily engaged in retailing merchandise, generally without transformation, and rendering services incidental to the sale of merchandise. The retailing process is the final step in the distribution of merchandise; retailers are therefore organized to sell merchandise in small quantities to the general public. Internet retail, direct selling, and mail-order retail are not separately classified from traditional in-store (also known as "brick and mortar") retail. Units that engage in retailing by any of these methods are classified based on the type of good sold. Meanwhile, vending machine operators are grouped with convenience retailers. In addition to selling merchandise, some types of retailers are also engaged in the provision of after-sales services, such as repair and installation. For example, new automobile dealers, electronic and appliance retailers and musical instrument and supplies retailers often provide repair services, while floor covering stores and window treatment retailers often provide installation services. As a general rule, establishments engaged in retailing merchandise and providing after sales services are classified in this sector.',
  },
  {
    code: '45',
    title: 'Retail trade',
    description:
      'This sector comprises establishments primarily engaged in retailing merchandise, generally without transformation, and rendering services incidental to the sale of merchandise. The retailing process is the final step in the distribution of merchandise; retailers are therefore organized to sell merchandise in small quantities to the general public. This sector comprises two main types of retailers, store and non-store retailers. Their main characteristics are described below. Store retailers Store retailers operate fixed point-of-sale locations, located and designed to attract a high volume of walk-in customers. In general, retail stores have extensive displays of merchandise and use mass-media advertising to attract customers. They typically sell merchandise to the general public for personal or household consumption, but some also serve businesses and institutions. These include establishments such as office supplies stores, computer and software stores, gasoline stations, building material dealers, plumbing supplies stores and electrical supplies stores. In addition to selling merchandise, some types of store retailers are also engaged in the provision of after-sales services, such as repair and installation. For example, new automobile dealers, electronic and appliance stores and musical instrument and supplies stores often provide repair services, while floor covering stores and window treatment stores often provide installation services. As a general rule, establishments engaged in retailing merchandise and providing after sales services are classified in this sector. Catalogue sales showrooms, gasoline service stations, and mobile home dealers are treated as store retailers. Non-store retailers Non-store retailers, like store retailers, are organized to serve the general public, but their retailing methods differ. They reach customers and market merchandise with methods such as, the broadcasting of infomercials, the broadcasting and publishing of direct-response advertising, the publishing of traditional and electronic catalogues, door-to-door solicitation, in-home demonstration, temporary displaying of merchandise (stalls) and distribution by vending machines. The methods of transaction and delivery of merchandise vary by type of non-store retailers. For example, non-store retailers that reach their customers using information technologies can receive payment at the time of purchase or at the time of delivery, and the delivery of the merchandise may be done by the retailer or by a third party, such as the post office or a courier. In contrast, non-store retailers that reach their customers by door-to-door solicitation, in-home demonstration, temporary displaying of merchandise (stalls) and vending machines typically receive payment and deliver the merchandise to the customer at the time of the purchase. Non-store retailers also include establishments engaged in the home delivery of products such as home heating oil dealers and newspaper delivery companies.',
  },
  {
    code: '48',
    title: 'Transportation and warehousing',
    description:
      'This sector comprises establishments primarily engaged in transporting passengers and goods, warehousing and storing goods, and providing services to these establishments. The modes of transportation are road (trucking, transit and ground passenger), rail, water, air and pipeline. These are further subdivided according to the way in which businesses in each mode organize their establishments. National post office and courier establishments, which also transport goods, are included in this sector. Warehousing and storage establishments are subdivided according to the type of service and facility that is operated. Many of the establishments in this sector are structured as networks, with activities, workers, and physical facilities distributed over an extensive geographic area.',
  },
  {
    code: '49',
    title: 'Transportation and warehousing',
    description:
      'This sector comprises establishments primarily engaged in transporting passengers and goods, warehousing and storing goods, and providing services to these establishments. The modes of transportation are road (trucking, transit and ground passenger), rail, water, air and pipeline. These are further subdivided according to the way in which businesses in each mode organize their establishments. National post office and courier establishments, which also transport goods, are included in this sector. Warehousing and storage establishments are subdivided according to the type of service and facility that is operated. Many of the establishments in this sector are structured as networks, with activities, workers, and physical facilities distributed over an extensive geographic area.',
  },
  {
    code: '51',
    title: 'Information and cultural industries',
    description:
      'This sector comprises establishments primarily engaged in producing and distributing (except by wholesale and retail methods) information and cultural products. Establishments providing the means to transmit or distribute these products or providing access to equipment and expertise for processing data are also included. The unique characteristics of information and cultural products, and of the processes involved in their production and distribution, distinguish this sector from the goods-producing and services-producing sectors. The value of these products lies in their information, educational, cultural or entertainment content, not in the format in which they are distributed. Distribution of these information and cultural products via the Internet are included. Most of these products are protected from unlawful reproduction by copyright laws. Only those possessing the rights to these works are authorized to reproduce, alter, improve and distribute them. Acquiring and using these rights often involves significant costs. The intangible nature of the content of information and cultural products allows for their distribution in various forms. For example, a movie can be shown at a movie theatre, on a television broadcast, through video on demand, or rented online; a sound recording can be aired on radio, distributed online, or sold at a record store; software can be bought at retail outlets or downloaded from the Internet; a newspaper can be purchased at a newsstand or read online. In addition, improvements in information technology are revolutionizing the distribution of these products. The inclusion in this sector of telecommunications services providers reflects the increasingly important role these establishments play in making these products accessible to the public. The main components of this sector are the motion picture and sound recording industries, the publishing industries, the broadcasting and content providers industries, the telecommunications industries, the computing infrastructure providers, data processing and hosting services industries, and the web search portals, libraries, archives, and other information services industries. There are establishments engaged in culture-related activities that are classified in other sectors of NAICS. The most important are listed as exclusions below.',
  },
  {
    code: '52',
    title: 'Finance and insurance',
    description:
      'This sector comprises establishments primarily engaged in financial transactions (that is, transactions involving the creation, liquidation, or change in ownership of financial assets) or in facilitating financial transactions. Included are: - establishments that are primarily engaged in financial intermediation. They raise funds by taking deposits and/or issuing securities, and, in the process, incur liabilities, which they use to acquire financial assets by making loans and/or purchasing securities. Putting themselves at risk, they channel funds from lenders to borrowers and transform or repackage the funds with respect to maturity, scale and risk. - establishments that are primarily engaged in the pooling of risk by underwriting annuities and insurance. They collect fees (insurance premiums or annuity considerations), build up reserves, invest those reserves and make contractual payments. Fees are based on the expected incidence of the insured risk and the expected return on investment. - establishments that are primarily engaged in providing specialized services that facilitate or support financial intermediation, insurance and employee benefit programs. In addition, establishments charged with monetary control - the monetary authorities - are included in this sector.',
  },
  {
    code: '53',
    title: 'Real estate and rental and leasing',
    description:
      'This sector comprises establishments primarily engaged in renting, leasing or otherwise allowing the use of tangible or intangible assets. Establishments primarily engaged in managing real estate for others; selling, renting and/or buying of real estate for others; and appraising real estate, are also included.',
  },
  {
    code: '54',
    title: 'Professional, scientific and technical services',
    description:
      'This sector comprises establishments primarily engaged in activities in which human capital is the major input. These establishments make available the knowledge and skills of their employees, often on an assignment basis. The individual industries of this sector are defined on the basis of the particular expertise and training of the service provider. The main components of this sector are legal services; accounting, tax preparation, bookkeeping and payroll services; architectural, engineering and related services; specialized design services; computer systems design and related services; management, scientific and technical consulting services; scientific research and development services; and advertising, public relations, and related services. The distinguishing feature of this sector is the fact that most of the industries grouped in it have production processes that are almost wholly dependent on worker skills. In most of these industries, equipment and materials are not of major importance. Thus, the establishments classified in this sector sell expertise. Much of the expertise requires a university or college education, though not in every case. Establishments primarily engaged in providing instruction and training in a wide variety of subjects and those primarily engaged in providing health care by diagnosis and treatment are not included in this sector.',
  },
  {
    code: '55',
    title: 'Management of companies and enterprises',
    description:
      'This sector comprises (1), comprises legal entities engaged only in holding the securities of subsidiaries and affiliates for the purpose of owning a controlling interest or influencing the management decisions of these businesses, or (2), establishments primarily engaged in administering, overseeing, and managing other establishments of the company or enterprise and which may also hold the securities of their subsidiaries and affiliates. A characteristic of economic units in this sector is that all activities are focused on serving the economic units of the enterprise group, that is, they do not provide services to unaffiliated establishment.',
  },
  {
    code: '56',
    title: 'Administrative and support, waste management and remediation services',
    description:
      'This sector comprises establishments of two different types: those primarily engaged in activities that support the day-to-day operations of other organizations; and those primarily engaged in waste management activities. The first type of establishment is engaged in activities such as administration, hiring and placing personnel, preparing documents, taking orders from clients, collecting payments for claims, arranging travel, providing security and surveillance, cleaning buildings, and packaging and labelling products. These activities are often undertaken, in-house, by establishments found in many sectors of the economy. The establishments classified to this sector specialize in one or more of these activities and can therefore provide services to clients in a variety of industries and, in some cases, to households. Waste management establishments are engaged in the collection, treatment and disposal of waste material, the operation of material recovery facilities, the remediation of polluted sites and the cleaning of septic tanks.',
  },
  {
    code: '61',
    title: 'Educational services',
    description:
      'This sector comprises establishments primarily engaged in providing instruction and training in a wide variety of subjects. This instruction and training is provided by specialized establishments, such as schools, colleges, universities and training centres. These establishments may be privately owned and operated, either for profit or not, or they may be publicly owned and operated. They may also offer food and accommodation services to their students. Educational services are usually delivered by teachers who explain, tell, demonstrate, supervise and direct self-learning. Instruction is imparted in diverse settings, such as educational institutions, the workplace or the home (through correspondence, television or other means). The lessons can be adapted to the particular needs of the students, for example sign language can replace verbal language for teaching students with hearing impairments. All industries in the sector share this commonality of process, namely, labour inputs of teachers with the requisite subject matter expertise and teaching ability.',
  },
  {
    code: '62',
    title: 'Health care and social assistance',
    description:
      'This sector comprises establishments primarily engaged in providing health care by diagnosis and treatment, providing residential care for medical and social reasons, and providing social assistance, such as counselling, welfare, child protection, community housing and food services, vocational rehabilitation and child care, to those requiring such assistance.',
  },
  {
    code: '71',
    title: 'Arts, entertainment and recreation',
    description:
      'This sector comprises establishments primarily engaged in operating facilities or providing services to meet the cultural, entertainment and recreational interests of their patrons. These establishments produce, promote or participate in live performances, events or exhibits intended for public viewing; provide the artistic, creative and technical skills necessary for the production of artistic products and live performances; preserve and exhibit objects and sites of historical, cultural or educational interest; and operate facilities or provide services that enable patrons to participate in sports or recreational activities or pursue amusement, hobbies and leisure-time interests. There are establishments engaged in activities related to arts and recreation that are classified in other sectors of NAICS. The most important are listed below.',
  },
  {
    code: '72',
    title: 'Accommodation and food services',
    description:
      'This sector comprises establishments primarily engaged in providing short-term lodging and complementary services to travellers, vacationers and others, in facilities such as hotels, motor hotels, resorts, motels, casino hotels, bed and breakfast accommodations, housekeeping cottages and cabins, recreational vehicle parks and campgrounds, hunting and fishing camps, and various types of recreational and adventure camps. This sector also comprises establishments primarily engaged in preparing meals, snacks and beverages, to customer orders, for immediate consumption on and off the premises.',
  },
  {
    code: '81',
    title: 'Other services (except public administration)',
    description:
      'This sector comprises establishments, not classified to any other sector, primarily engaged in repairing, or performing general or routine maintenance, on motor vehicles, machinery, equipment and other products to ensure that they work efficiently; providing personal care services, funeral services, laundry services and other services to individuals, such as pet care services and photo finishing services; organizing and promoting religious activities; supporting various causes through grant-making, advocating (promoting) various social and political causes, and promoting and defending the interests of their members. Private households are also included.',
  },
  {
    code: '91',
    title: 'Public administration',
    description:
      'This sector comprises establishments primarily engaged in activities of a governmental nature, that is, the enactment and judicial interpretation of laws and their pursuant regulations, and the administration of programs based on them. Legislative activities, taxation, national defence, public order and safety, immigration services, foreign affairs and international assistance, and the administration of government programs are activities that are purely governmental in nature. Ownership is not a criterion for classification. Government owned establishments engaged in activities that are not governmental in nature are classified to the same industry as privately owned establishments engaged in similar activities. Government establishments may engage in a combination of governmental and non-governmental activities. When separate records are not available to separate the activities that are not governmental in nature from those that are, the establishment is classified to this sector.',
  },
  {
    code: '111',
    title: 'Crop production',
    description:
      "This subsector comprises establishments, such as farms, orchards, groves, greenhouses and nurseries, primarily engaged in growing crops, plants, vines, trees and their seeds (excluding those engaged in forestry operations). Industries have been created taking into account input factors, such as suitable land, climatic conditions, type of equipment, and the amount and type of labour required. The production process is typically completed when the raw product or commodity grown reaches the farm gate for market, that is, at the point of first sale or price determination. Establishments in these industries may use traditional crop production methods, employ modified or improved crop inputs, or engage in organic crop production. An establishment is classified within this subsector provided that 50 percent or more of the establishment's agricultural production consists of crops. Establishments with 50 percent or more crop production and with no one product or family of products accounting for 50 percent of the production are treated as combination crop farms and classified to 11199 All other crop farming, except if 50 percent or more of the production is a combination of oilseeds and grains, in which case they are classified to 11119 Other grain farming.",
  },
  {
    code: '112',
    title: 'Animal production and aquaculture',
    description:
      "This subsector comprises establishments, such as ranches, farms and feedlots, primarily engaged in raising animals, producing animal products and fattening animals. Industries have been created taking into account input factors such as suitable grazing or pasture land, specialized buildings, type of equipment, and the amount and type of labour required. An establishment is classified within this subsector provided that 50 percent or more of the establishment's agricultural production consists of animal production or aquaculture. Establishments with 50 percent or more animal production or aquaculture and with no one product or family of products accounting for 50 percent of the production are treated as combination animal farms and classified to 11299 All other animal production.",
  },
  {
    code: '113',
    title: 'Forestry and logging',
    description:
      'This subsector comprises establishments primarily engaged in growing and harvesting timber on a long production cycle (of ten years or more). Long production cycles use different production processes than short production cycles, which require more horticultural interventions prior to harvest, resulting in processes more similar to those found in the Crop production subsector. Consequently, Christmas tree production and other production involving production cycles of less than ten years, are classified to the Crop production subsector. Industries in this subsector specialize in different stages of the production cycle. Reforestation requires production of seedlings in specialized nurseries. Timber production requires natural forests or suitable areas of land that are available for a long duration. The maturation time for timber depends upon the species of tree, the climatic conditions of the region, and the intended purpose of the timber. The harvesting of timber, except when done on an extremely small scale, requires specialized machinery unique to the industry. The gathering of forest products, such as gums, barks, balsam needles and Spanish moss, are also included in this subsector.',
  },
  {
    code: '114',
    title: 'Fishing, hunting and trapping',
    description:
      'This subsector comprises establishments primarily engaged in catching fish and other wild animals from their natural habitats. These establishments are dependent upon a continued supply of the natural resource. The catching of fish is the predominant economic activity of this subsector and it usually requires specialized vessels that, by the nature of their size, configuration and equipment, are not suitable for any other type of production, such as transportation. Hunting and trapping utilize a wide variety of production processes and are classified in the same subsector as fishing because the availability of resources and the constraints imposed, such as conservation requirements and proper habitat maintenance, are similar.',
  },
  {
    code: '115',
    title: 'Support activities for agriculture and forestry',
    description:
      'This subsector comprises establishments primarily engaged in providing support services that are essential to agricultural and forestry production.',
  },
  {
    code: '211',
    title: 'Oil and gas extraction',
    description:
      'This subsector comprises establishments primarily engaged in operating oil and gas field properties. Such activities may include exploration for crude petroleum and natural gas; drilling, completing and equipping wells; operating separators, emulsion breakers, desilting equipment and field gathering lines for crude petroleum; and all other activities in the preparation of oil and gas up to the point of shipment from the producing property. This subsector includes the production of oil, the mining and extraction of oil from oil shale and oil sands, and the production of gas and hydrocarbon liquids, through gasification, liquefaction and pyrolysis of coal at the mine site.',
  },
  {
    code: '212',
    title: 'Mining and quarrying (except oil and gas)',
    description:
      'This subsector comprises establishments primarily engaged in mining, beneficiating or otherwise preparing metallic and non-metallic minerals, including coal.',
  },
  {
    code: '213',
    title: 'Support activities for mining, and oil and gas extraction',
    description:
      'This subsector comprises establishments primarily engaged in providing support services, on a contract or fee basis, for the mining and quarrying of minerals and for the extraction of oil and gas. Establishments engaged in the exploration for minerals, other than oil or gas, are included. Exploration includes traditional prospecting methods, such as taking ore samples and making geological observations at prospective sites.',
  },
  {
    code: '221',
    title: 'Utilities',
    description:
      'This subsector comprises establishments primarily engaged in operating electric, gas and water utilities. These establishments generate, transmit, control and distribute electric power; distribute natural gas; treat and distribute water; operate sewer systems and sewage treatment facilities; and provide related services, generally through a permanent infrastructure of lines, pipes and treatment and processing facilities.',
  },
  {
    code: '236',
    title: 'Construction of buildings',
    description:
      'This subsector comprises establishments primarily engaged in the construction of buildings. Buildings are distinguished by their primary function, such as residential, commercial and industrial. Establishments may produce new construction, or undertake additions, alterations, or maintenance and repairs to existing structures. The on-site assembly of precast, panelized, and prefabricated buildings and construction of temporary buildings are included in this subsector. Part or all of the production work for which the establishments in this subsector have responsibility may be subcontracted to other construction establishments - usually specialty trade contractors.',
  },
  {
    code: '237',
    title: 'Heavy and civil engineering construction',
    description:
      'This subsector comprises establishments whose primary activity is the construction of entire engineering projects (e.g., highways and dams), and specialty trade contractors, whose primary activity is the production of a specific component for such projects. Establishments may produce new construction, or undertake additions, alterations, or maintenance and repairs to existing structures and works. Establishments in this subsector are classified based on the types of structures that they construct. Specialty trade contractors in this subsector generally provide specialized services of a type related to heavy and civil engineering construction projects and not normally performed on buildings or building related projects. For example, specialized equipment is needed to paint lines on highways. This equipment is not normally used in building applications so the activity is classified in this subsector. Traffic signal installation, while specific to highways, uses much of the same skills and equipment that are needed for electrical work in building projects and is therefore classified in subsector 238 Specialty trade contractors. Construction projects involving water resources (e.g., dredging and land drainage) and projects involving open space improvement (e.g., parks and trails) are included in this subsector. Establishments whose primary activity is the subdivision of land into individual building lots usually perform various additional site-improvement activities (e.g., road building and utility line installation) and are included in this subsector.',
  },
  {
    code: '238',
    title: 'Specialty trade contractors',
    description:
      'This subsector comprises establishments primarily engaged in trade activities generally needed in the construction of buildings and structures, such as masonry, painting, or electrical work. The work performed may include new work, additions, alterations, maintenance, and repairs. Specialty trade contractors usually work under contract to general contractors or operative builders to carry out a component of an overall project. However, they may contract directly with the owner of the property, especially in renovation and repair construction. Not all specialized trade activities are classified in this subsector. In order to conform to the generally accepted distinctions made by construction businesses themselves, some types of specialized establishments involved in heavy and civil engineering construction are classified in subsector 237 Heavy and civil engineering construction. Usually most of the work is carried out at the construction site. Some trade contractors operate shops in which they carry out job-specific prefabrication and other work. However, establishments that manufacture structural components such as steel and pre-cast concrete, or that manufacture building equipment such as boilers and elevators, are classified in sector 31-33 Manufacturing even if they install these goods themselves. The specialized activities classified in this subsector range from the initial site preparation for new construction, through the construction of building foundations and structures, the installation of building equipment and systems, to the finishing of buildings and other structures.',
  },
  {
    code: '311',
    title: 'Food manufacturing',
    description:
      'This subsector comprises establishments primarily engaged in producing food for human or animal consumption.',
  },
  {
    code: '312',
    title: 'Beverage and tobacco product manufacturing',
    description:
      'This subsector comprises establishments primarily engaged in manufacturing beverages and tobacco products.',
  },
  {
    code: '313',
    title: 'Textile mills',
    description:
      'This subsector comprises establishments primarily engaged in manufacturing yarn or textile fabrics, or finishing yarn, textile fabrics or clothing. Establishments primarily engaged in manufacturing both fabrics and textile products, except knitted clothing, are included.',
  },
  {
    code: '314',
    title: 'Textile product mills',
    description:
      'This subsector comprises establishments primarily engaged in manufacturing textile products, except clothing.',
  },
  {
    code: '315',
    title: 'Apparel manufacturing',
    description: 'This subsector comprises establishments primarily engaged in manufacturing clothing.',
  },
  {
    code: '316',
    title: 'Leather and allied product manufacturing',
    description:
      'This subsector comprises establishments primarily engaged in manufacturing leather and allied products.',
  },
  {
    code: '321',
    title: 'Wood product manufacturing',
    description:
      'This subsector comprises establishments primarily engaged in manufacturing products from wood. There are three industry groups in this subsector, comprising establishments engaged in sawing logs into lumber and similar products, or preserving these products; making products that improve the natural characteristics of wood, by making veneers, plywood, reconstituted wood panel products or engineered wood assemblies; and making a diverse range of wood products, such as millwork.',
  },
  {
    code: '322',
    title: 'Paper manufacturing',
    description:
      'This subsector comprises establishments primarily engaged in manufacturing pulp, paper and paper products. The manufacture of pulp involves separating the cellulose fibres from other impurities in wood, used paper or other fibre sources. The manufacture of paper involves matting these fibres into a sheet. Converted paper products are produced from paper and other materials by various cutting and shaping techniques.',
  },
  {
    code: '323',
    title: 'Printing and related support activities',
    description:
      'This subsector comprises establishments primarily engaged in printing and providing related support activities.',
  },
  {
    code: '324',
    title: 'Petroleum and coal product manufacturing',
    description:
      'This subsector comprises establishments primarily engaged in transforming crude petroleum and coal into intermediate and end products. The dominant process is petroleum refining, which separates crude petroleum into components or fractions through such techniques as cracking and distillation.',
  },
  {
    code: '325',
    title: 'Chemical manufacturing',
    description:
      'This subsector comprises establishments primarily engaged in manufacturing chemicals and chemical preparations, from organic and inorganic raw materials.',
  },
  {
    code: '326',
    title: 'Plastics and rubber products manufacturing',
    description:
      'This subsector comprises establishments primarily engaged in making goods by processing raw rubber and plastics materials. Rubber and plastics-based activities are combined in the same subsector because the technical properties of these polymers are related. Generally, establishments classified in this subsector manufacture products made of just one material, rubber or plastics, with the major exception of tire manufacturing.',
  },
  {
    code: '327',
    title: 'Non-metallic mineral product manufacturing',
    description:
      'This subsector comprises establishments primarily engaged in manufacturing non-metallic mineral products. These establishments cut, grind, shape and finish granite, marble, limestone, slate and other stone; mix non-metallic minerals with chemicals and other additives; and heat non-metallic mineral preparations to make products, such as bricks, refractories, ceramic products, cement and glass.',
  },
  {
    code: '331',
    title: 'Primary metal manufacturing',
    description:
      'This subsector comprises establishments primarily engaged in smelting and refining ferrous and non-ferrous metals from ore, pig or scrap in blast or electric furnaces. Metal alloys are made with the introduction of other chemical elements. The output of smelting and refining, usually in ingot form, is used in rolling and drawing operations to produce sheet, strip, bars, rods and wire, and in molten form to produce castings and other basic metal products.',
  },
  {
    code: '332',
    title: 'Fabricated metal product manufacturing',
    description:
      'This subsector comprises establishments primarily engaged in forging, stamping, forming, turning and joining processes to produce ferrous and non-ferrous metal products, such as cutlery and hand tools, architectural and structural metal products, boilers, tanks and shipping containers, hardware, spring and wire products, turned products, and bolts, nuts and screws.',
  },
  {
    code: '333',
    title: 'Machinery manufacturing',
    description:
      'This subsector comprises establishments primarily engaged in manufacturing industrial and commercial machinery. These establishments assemble parts into components, subassemblies and complete machines. They may make the parts themselves, using general metal-working processes, or purchase them. Establishments tend to specialize in producing machinery designed for particular applications, and this is reflected in the structure of the industry groups and industries. A broad distinction exists between general-purpose machinery, that is designed to be used in a variety of industrial applications, such as pumping or machining, and special-purpose machinery, that is designed to be used in a particular industry, such as agriculture or printing. The first three industry groups consist of establishments that produce special-purpose machinery. Establishments that produce general-purpose machinery are classified in the remaining industry groups. Establishments primarily engaged in rebuilding machinery are included in the same industry as establishments manufacturing the particular type of new machinery. Unless otherwise specified, establishments primarily engaged in manufacturing parts, designed for use solely or principally with a particular machine, are classified in the same industry as establishments manufacturing that type of machinery.',
  },
  {
    code: '334',
    title: 'Computer and electronic product manufacturing',
    description:
      'This subsector comprises establishments primarily engaged in manufacturing computers, computer peripheral equipment, communications equipment, and similar electronic products, as well as components for such products. The computer and electronic product manufacturing industries employ production processes that are characterized by the design and use of integrated circuits and the application of highly specialized miniaturization technologies.',
  },
  {
    code: '335',
    title: 'Electrical equipment, appliance and component manufacturing',
    description:
      'This subsector comprises establishments primarily engaged in manufacturing products that generate, distribute and use electrical power.',
  },
  {
    code: '336',
    title: 'Transportation equipment manufacturing',
    description:
      'This subsector comprises establishments primarily engaged in manufacturing equipment for transporting people and goods. The industry groups are based on the various modes of transport - road, rail, air and water. Three industry groups are based on road transportation equipment - for complete vehicles, for body and trailer manufacture and for parts. Establishments primarily engaged in rebuilding equipment and parts are included in the same industry as establishments manufacturing new products.',
  },
  {
    code: '337',
    title: 'Furniture and related product manufacturing',
    description:
      "This subsector comprises establishments primarily engaged in manufacturing furniture and related products. The processes used in the manufacture of furniture are standard methods of forming materials and assembling components, including cutting, moulding and laminating. The design of the article, for both aesthetic and functional qualities, is an important aspect of the production process. Design services may be performed by the furniture establishment's own work force or may be purchased from industrial designers. Furniture is classified based on the application for which it is designed. For example, an upholstered sofa is treated as household furniture, although it may also be used in hotels or offices. Furniture is also classified according to the component material from which it is made. Furniture made from more than one material is classified based on the material used in the frame, or if there is no frame, the predominant component material. Upholstered household furniture is classified as such, without regard to the frame material. Furniture may be produced on a stock or custom basis and may be shipped assembled or unassembled (knockdown). Establishments primarily engaged in manufacturing furniture frames and parts are included.",
  },
  {
    code: '339',
    title: 'Miscellaneous manufacturing',
    description:
      'This subsector comprises establishments, not classified to any other subsector, primarily engaged in manufacturing activities. These establishments manufacture a diverse range of products, such as medical equipment and supplies, jewellery, sporting goods, toys and office supplies.',
  },
  {
    code: '411',
    title: 'Farm product merchant wholesalers',
    description:
      'This subsector comprises establishments primarily engaged in wholesaling livestock, grain and other farm products.',
  },
  {
    code: '412',
    title: 'Petroleum, petroleum products, and other hydrocarbons merchant wholesalers',
    description:
      'This subsector comprises establishments primarily engaged in wholesaling crude oil, liquefied petroleum gases, heating oil and other refined petroleum products and hydrocarbons.',
  },
  {
    code: '413',
    title: 'Food, beverage and tobacco merchant wholesalers',
    description:
      'This subsector comprises establishments primarily engaged in wholesaling food products, beverages and tobacco products.',
  },
  {
    code: '414',
    title: 'Personal and household goods merchant wholesalers',
    description:
      'This subsector comprises establishments primarily engaged in wholesaling textiles, clothing, footwear, home entertainment equipment, household appliances, home furnishings, personal articles, pharmaceuticals, toiletries, cosmetics and sundries.',
  },
  {
    code: '415',
    title: 'Motor vehicle and motor vehicle parts and accessories merchant wholesalers',
    description:
      'This subsector comprises establishments primarily engaged in wholesaling motor vehicles, parts and accessories, including tires.',
  },
  {
    code: '416',
    title: 'Building material and supplies merchant wholesalers',
    description:
      'This subsector comprises establishments primarily engaged in wholesaling electrical, plumbing, heating and air-conditioning equipment and supplies, metal and metal products, lumber, millwork, hardware and other building supplies.',
  },
  {
    code: '417',
    title: 'Machinery, equipment and supplies merchant wholesalers',
    description:
      'This subsector comprises establishments primarily engaged in wholesaling farm, lawn and garden machinery and equipment; construction, forestry, mining and industrial machinery, equipment and supplies; computers and communication equipment and supplies; and other machinery, equipment and supplies.',
  },
  {
    code: '418',
    title: 'Miscellaneous merchant wholesalers',
    description:
      'This subsector comprises establishments, not classified to any other subsector, primarily engaged in wholesaling merchandise, such as recyclable materials, paper, paper products and disposable plastic products, agricultural supplies, chemicals and allied products, logs and wood chips, minerals, ores and precious metals, and second-hand goods (except machinery and automotive).',
  },
  {
    code: '419',
    title: 'Business-to-business electronic markets, and agents and brokers',
    description:
      "This subsector comprises establishments primarily engaged in buying and/or selling products, owned by others, and generally receiving a fee or a commission for the service. These establishments may be known as business-to-business electronic markets, commission merchants, import agents or brokers, export agents or brokers, manufacturers' agents, purchasing agents, selling agents, and they may deal in any type of product. These establishments bring together sellers and buyers or undertake commercial transactions on behalf of a principal, without taking title of the goods bought or sold.",
  },
  {
    code: '441',
    title: 'Motor vehicle and parts dealers',
    description:
      'This subsector comprises establishments primarily engaged in retailing motor vehicles and providing complementary services, and retailing motor vehicle parts and accessories. The establishments of this subsector are generally specialized in the retailing of particular types of vehicles or in the retailing of particular types of parts and accessories.',
  },
  {
    code: '442',
    title: 'Furniture and home furnishings stores',
    description:
      'This subsector comprises establishments primarily engaged in retailing new furniture and home furnishings. These establishments usually operate from showrooms and many offer interior decorating services in addition to the sale of products.',
    isExpired: true,
  },
  {
    code: '443',
    title: 'Electronics and appliance stores',
    description:
      'This subsector comprises establishments primarily engaged in retailing household appliances, home audio and video equipment, audio and video recordings, cameras, computers and related goods. These establishments may also retail replacement parts and provide repair services.',
    isExpired: true,
  },
  {
    code: '444',
    title: 'Building material and garden equipment and supplies dealers',
    description:
      'This subsector comprises establishments primarily engaged in retailing a specialized or general line of building and home improvement materials, lawn and garden equipment and supplies, outdoor power equipment, and nursery and garden products.',
  },
  {
    code: '445',
    title: 'Food and beverage retailers',
    description:
      'This subsector comprises establishments primarily engaged in retailing a general or specialized line of food or beverage products.',
  },

  {
    code: '446',
    title: 'Health and personal care stores',
    description:
      'This subsector comprises establishments primarily engaged in retailing health and personal care products. Drug stores and pharmacies, cosmetics, beauty supplies and perfume stores, optical goods stores, food (health) supplement stores and health appliance stores are included.',
    isExpired: true,
  },
  {
    code: '447',
    title: 'Gasoline stations',
    description:
      'This subsector comprises establishments primarily engaged in retailing motor fuels, whether or not the gasoline station is operated in conjunction with a convenience store, repair garage, restaurant or other type of operation. Establishments that operate gasoline stations on behalf of their owners and receive a commission on the sale of fuels are also included.',
    isExpired: true,
  },
  {
    code: '448',
    title: 'Clothing and clothing accessories stores',
    description:
      'This subsector comprises establishments primarily engaged in retailing clothing and clothing accessories.',
    isExpired: true,
  },
  {
    code: '449',
    title: 'Furniture, home furnishings, electronics and appliances retailers',
    description:
      'This subsector comprises establishments primarily engaged in retailing new furniture, home furnishings, household appliances, home audio and video equipment, audio and video recordings, cameras, computers and related goods. Many of these establishments offer interior decorating services in addition to the sale of products. These establishments may also retail replacement parts and provide repair services.',
  },
  {
    code: '451',
    title: 'Sporting goods, hobby, book and music stores',
    description:
      'This subsector comprises establishments primarily engaged in retailing sporting goods, games and toys, sewing supplies, fabrics, patterns, yarns and other needlework accessories, musical instruments, and books and other reading materials.',
    isExpired: true,
  },
  {
    code: '452',
    title: 'General merchandise stores',
    description:
      'This subsector comprises establishments primarily engaged in retailing a general line of merchandise that may, or may not, include a general line of grocery items.',
    isExpired: true,
  },
  {
    code: '453',
    title: 'Miscellaneous store retailers',
    description:
      'This subsector comprises establishments primarily engaged in retailing a specialized line of merchandise in other types of specialty stores. Florists, office supplies stores, stationery stores, gift, novelty and souvenir stores, used merchandise stores, pet and pet supplies stores, art dealers and manufactured (mobile) home dealers are included.',
    isExpired: true,
  },
  {
    code: '454',
    title: 'Non-store retailers',
    description:
      'This subsector comprises establishments primarily engaged in retailing merchandise by non-store retail methods. The establishments of this subsector employ methods, such as broadcasting infomercials, broadcasting and publishing direct-response advertising, publishing traditional and electronic catalogues, door-to-door solicitation, in-home demonstration, temporary displaying of merchandise (temporary stands or stalls), distribution by vending machines, and using the Internet to reach their customers and market their merchandise. Establishments primarily engaged in the direct sale (i.e. non-store) of products such as home heating fuels and in newspaper delivery are also included.',
    isExpired: true,
  },
  {
    code: '455',
    title: 'General merchandise retailers',
    description:
      'This subsector comprises establishments primarily engaged in retailing a general line of merchandise that may, or may not, include a general line of grocery items.',
  },
  {
    code: '456',
    title: 'Health and personal care retailers',
    description:
      'This subsector comprises establishments primarily engaged in retailing health and personal care products. Drug stores and pharmacies, cosmetics, beauty supplies and perfume retailers, optical goods retailers food (health) supplement retailers and health appliance retailers are included.',
  },
  {
    code: '457',
    title: 'Gasoline stations and fuel vendors',
    description:
      'This subsector comprises establishments primarily engaged in retailing motor fuels, whether or not the gasoline station is operated in conjunction with a convenience store, repair garage, restaurant or other type of operation. Establishments that operate gasoline stations on behalf of their owners and receive a commission on the sale of fuels are also included. It also comprises establishments primarily engaged in retailing heating oil, liquefied petroleum gas (LPG) and other fuels via direct selling.',
  },
  {
    code: '458',
    title: 'Clothing, clothing accessories, shoes, jewelry, luggage and leather goods retailers',
    description:
      'This subsector comprises establishments primarily engaged in retailing clothing, clothing accessories, shoes, jewelry, luggage and leather goods.',
  },
  {
    code: '459',
    title: 'Sporting goods, hobby, musical instrument, book, and miscellaneous retailers',
    description:
      'This subsector comprises establishments engaged in retailing  sporting goods, games and toys, sewing supplies, fabrics, patterns, yarns and other needlework accessories, musical instruments, and books and other reading materials. It is also engaged in retailing a specialized line of merchandise in other types of specialty stores. Florists, office supplies stores, stationery stores, gift, novelty and souvenir stores, used merchandise stores, pet and pet supplies stores, art dealers and manufactured (mobile) home dealers are included.',
  },
  {
    code: '481',
    title: 'Air transportation',
    description:
      'This subsector comprises establishments primarily engaged in for-hire, common-carrier transportation of people and/or goods using aircraft, such as airplanes and helicopters.',
  },
  {
    code: '482',
    title: 'Rail transportation',
    description:
      'This subsector comprises establishments primarily engaged in operating railways. Establishments primarily engaged in the operation of long-haul or mainline railways, short-haul railways and passenger railways are included.',
  },
  {
    code: '483',
    title: 'Water transportation',
    description:
      'This subsector comprises establishments primarily engaged in the water transportation of passengers and goods, using equipment designed for those purposes.',
  },
  {
    code: '484',
    title: 'Truck transportation',
    description:
      'This subsector comprises establishments primarily engaged in the truck transportation of goods. These establishments may carry general freight or specialized freight. Specialized freight comprises goods that, because of size, weight, shape or other inherent characteristics, require specialized equipment for transportation. Establishments may operate locally, that is within a metropolitan area and its hinterland, or over long distances, that is between metropolitan areas.',
  },
  {
    code: '485',
    title: 'Transit and ground passenger transportation',
    description:
      'This subsector comprises establishments primarily engaged in a variety of passenger transportation activities, using equipment designed for those purposes. These activities are distinguished based on process factors, such as whether routes are scheduled, run over fixed routes, and charged on a per-seat or per-vehicle basis.',
  },
  {
    code: '486',
    title: 'Pipeline transportation',
    description:
      'This subsector comprises establishments primarily engaged in the transport of goods by pipeline. The pipelines are designed to specifications for the transport of a particular good, such as crude oil, natural gas and refined petroleum products. Pipeline transportation includes integrated systems comprising various types of pipelines and ancillary facilities, such as pumping stations and incidental storage facilities.',
  },
  {
    code: '487',
    title: 'Scenic and sightseeing transportation',
    description:
      'This subsector comprises establishments primarily engaged in providing recreational transportation, such as sightseeing or dinner cruises, steam train excursions, horse-drawn sightseeing rides, air-boat rides or hot-air balloon rides. These establishments often use vintage or specialized transportation equipment. The services provided are local in nature, usually involving same-day return. Establishments that provide charter fishing services are included.',
  },
  {
    code: '488',
    title: 'Support activities for transportation',
    description:
      'This subsector comprises establishments primarily engaged in providing services to other transportation establishments. These services may be specific to a mode of transportation, or they may be multi-modal.',
  },
  {
    code: '491',
    title: 'Postal service',
    description:
      'This subsector comprises establishments primarily engaged in operating the postal service. Establishments of the Post Office, other than those primarily engaged in providing courier services, are classified in this industry, as well as establishments that carry on one or more functions of the postal service on a contract basis, except the delivery of mail in bulk.',
  },
  {
    code: '492',
    title: 'Couriers and messengers',
    description:
      'This subsector comprises establishments primarily engaged in providing courier delivery services; or messenger and delivery services of small parcels within a single urban area.',
  },
  {
    code: '493',
    title: 'Warehousing and storage',
    description:
      "This subsector comprises establishments primarily engaged in operating general merchandise, refrigerated and other warehousing and storage facilities. Included in this subsector are third-party warehouses serving retail chains and wholesalers. Establishments in this subsector provide facilities to store goods for customers. They do not take title to the goods they handle. These establishments take responsibility for storing the goods and keeping them secure. They may also provide a range of services, often referred to as logistics services, related to the distribution of a customer's goods. Logistics services can include labelling, breaking bulk, inventory control and management, light assembly, order entry and fulfillment, packaging, pick and pack, price marking and ticketing and transportation arrangement. However, establishments in this subsector always provide storage services in addition to any logistics services. Furthermore, the storage of goods must be more than incidental to the performance of a service such as price marking. Both public and contract warehousing are included in this subsector. Public warehousing generally provides short-term storage, typically for less than thirty days. Contract warehousing generally involves a longer-term contract, often including the provision of logistical services and dedicated facilities. Bonded warehousing and storage services, and warehouses located in free trade zones, are included in the industries of this subsector. However, storage services primarily associated with the provision of credit are not.",
  },
  {
    code: '511',
    title: 'Publishing industries',
    description:
      "This subsector comprises establishments primarily engaged in publishing newspapers, periodicals, books, databases, software and other works. These works are characterized by the intellectual creativity required in their development and are usually protected by copyright. Publishers distribute, or arrange for the distribution of copies of these works. Publishing establishments may create the works in-house, or contract for, purchase, or compile works that were originally created by others. These works may be published in one or more formats including traditional print form, electronic and online. Publishers of multimedia products, such as interactive children's books, multimedia CD-ROM and digital video disk (DVD) reference books, and musical greeting cards are also included. Establishments in this subsector may print, reproduce or offer direct online access to the works themselves or they may arrange with others to carry out such functions.",
    isExpired: true,
  },
  {
    code: '512',
    title: 'Motion picture and sound recording industries',
    description:
      'This subsector comprises establishments primarily engaged in producing and distributing video and audio recordings or providing related services, such as post-production services, exhibition services, and motion picture processing and developing services. Sound recording studios are also included.',
  },
  {
    code: '513',
    title: 'Publishing industries',
    description:
      "This subsector comprises establishments primarily engaged in publishing newspapers, periodicals, books, databases, software and other works. These works are characterized by the intellectual creativity required in their development and are usually protected by copyright. Publishers distribute, or arrange for the distribution of copies of these works. Publishing establishments may create the works in-house, or contract for, purchase, or compile works that were originally created by others. These works may be published in one or more formats including traditional print form, digital and online. Publishers of multimedia products, such as interactive children's books, multimedia CD-ROM and digital video disk (DVD) reference books, multimedia digital books, and musical greeting cards are also included. Establishments in this subsector may print, reproduce or offer direct online access to the works themselves or they may arrange with others to carry out such functions.",
  },

  {
    code: '515',
    title: 'Broadcasting (except Internet)',
    description:
      'This subsector comprises establishments primarily engaged in operating radio and television broadcasting studios and facilities.',
    isExpired: true,
  },
  {
    code: '516',
    title: 'Broadcasting and content providers',
    description:
      'This subsector comprises establishments primarily engaged in operating radio or television broadcasting stations for programming and transmission to the public. Programming may originate in their own studio, from an affiliated network, or from external sources. This subsector also comprises establishments primarily engaged in providing media streaming distribution services, operating media broadcasting, satellite and cable television networks, and supplying information, such as news reports, articles, pictures, and features, to the news media. These may operate by cable systems, satellite transmission or over the Internet. These establishments distribute textual, audio, and/or video content of general or specific interest.',
  },
  {
    code: '517',
    title: 'Telecommunications',
    description:
      'This subsector comprises establishments primarily engaged in providing telecommunications and/or video entertainment services over their own networks, or over networks operated by others. The establishments of this subsector are grouped into industries on the basis of the nature of services provided (fixed or mobile), the type of network used to deliver those services (wireline or wireless), and the business model they employ (facilities-based or resale).',
  },
  {
    code: '518',
    title: 'Computing infrastructure providers, data processing, web hosting, and related services',
    description:
      'This subsector comprises establishments primarily engaged in providing the infrastructure for data processing, hosting, and related services.',
  },
  {
    code: '519',
    title: 'Web search portals, libraries, archives, and all other information services',
    description:
      'This subsector comprises establishments, not classified to any other industry, primarily engaged in providing other information services. The main components are web search portals, libraries and archives, and all other information services.',
  },
  {
    code: '521',
    title: 'Monetary authorities - central bank',
    description:
      "This subsector comprises establishments primarily engaged in performing central banking functions, such as issuing currency (paper money); managing the nation's money supply and international reserves; overseeing payment, clearing and settlement systems; holding deposits that represent the reserves of other banks and institutions; and acting as fiscal agent for the federal government. The institutional arrangements for performing these functions and for conducting monetary policy may differ among the countries. In Canada, these functions are performed by the Bank of Canada, in Mexico by the Bank of Mexico, and in the United States by the Federal Reserve Banks and their branches.",
  },
  {
    code: '522',
    title: 'Credit intermediation and related activities',
    description:
      'This subsector comprises establishments primarily engaged in lending funds raised from depositors or by issuing debt securities and establishments that facilitate the lending of funds or issuance of credit by engaging in such activities as mortgage and loan brokerage, clearinghouse and reserve services, and cheque-cashing services.',
  },
  {
    code: '523',
    title: 'Securities, commodity contracts, and other financial investment and related activities',
    description:
      'This subsector comprises establishments primarily engaged in putting capital at risk in the process of underwriting securities issues or in making markets for securities and commodities; acting as intermediaries between buyers and sellers of securities; providing securities and commodity exchange services (furnishing space, marketplaces, and often facilities for the purpose of facilitating the buying and selling of stocks, stock options, bonds or commodity contracts); facilitating the marketing of financial contracts; asset management (managing portfolios of securities); and providing investment advice, trust, fiduciary, custody and other investment services.',
  },
  {
    code: '524',
    title: 'Insurance carriers and related activities',
    description:
      'This subsector comprises establishments primarily engaged in underwriting annuities, insurance policies and reinsurance, and the retailing of insurance and the provision of related services to policy holders. Industries are defined in terms of the type of risk being insured against, such as death, loss of employment due to age or disability, and property damage. Establishments that pool risk invest premiums to build up a portfolio of financial assets to be used against future claims. Contributions and premiums are set on the basis of actuarial calculations of probable payouts based on risk factors from experience tables and expected investment returns on reserves.',
  },
  {
    code: '526',
    title: 'Funds and other financial vehicles',
    description:
      'This subsector comprises funds, trusts and other financial vehicles organized to hold portfolio assets for the benefit of others, such as unit holders, beneficiaries of pension funds, and investors. These entities earn interest, dividends and other property income, but have little or no employment and no revenue from the sale of services.',
  },
  {
    code: '531',
    title: 'Real estate',
    description:
      'This subsector comprises establishments primarily engaged in renting and leasing real estate, managing real estate for others, acting as intermediaries in the sale and/or rental of real estate, and appraising real estate.',
  },
  {
    code: '532',
    title: 'Rental and leasing services',
    description:
      'This subsector comprises establishments primarily engaged in renting or leasing tangible goods, such as automobiles, computers, consumer goods, and industrial machinery and equipment, to customers in return for a periodic payment. The subsector includes two main types of establishments: - those that are engaged in renting consumer goods and equipment; and\n- those that are engaged in leasing machinery and equipment of the kind often used for business operations. The first type typically operates from a retail-like or store-front facility and maintains inventories of goods that are rented for short periods of time. The latter type typically does not operate from retail-like locations or maintain inventories, and offers longer-term leases. These establishments work directly with clients by providing or arranging financing to enable them to acquire the use of equipment on a lease basis; or they work with equipment vendors or dealers to support the marketing of equipment to their customers under lease arrangements. Equipment lessors generally structure lease contracts to meet the specialized needs of their clients and use their remarketing expertise to find other users for previously leased equipment. Establishments that provide operating and financial leases are included in this subsector.',
  },
  {
    code: '533',
    title: 'Lessors of non-financial intangible assets (except copyrighted works)',
    description:
      'This subsector comprises establishments primarily engaged in holding non-financial intangible assets such as patents, trademarks, brand names, and/or franchise agreements, and allowing others to use or reproduce those assets for a fee.',
  },
  {
    code: '541',
    title: 'Professional, scientific and technical services',
    description:
      'This subsector comprises establishments primarily engaged in activities in which human capital is the major input. These establishments make available the knowledge and skills of their employees, often on an assignment basis. The individual industries of this subsector are defined on the basis of the particular expertise and training of the service provider. The main components of this subsector are legal services; accounting, tax preparation, bookkeeping and payroll services; architectural, engineering and related services; specialized design services; computer systems design and related services; management, scientific and technical consulting services; scientific research and development services; and advertising, public relations, and related services. The distinguishing feature of this subsector is the fact that most of the industries grouped in it have production processes that are almost wholly dependent on worker skills. In most of these industries, equipment and materials are not of major importance. Thus, the establishments classified in this subsector sell expertise. Much of the expertise requires a university or college education, though not in every case. Establishments primarily engaged in providing instruction and training in a wide variety of subjects and those primarily engaged in providing health care by diagnosis and treatment are not included in this subsector.',
  },
  {
    code: '551',
    title: 'Management of companies and enterprises',
    description:
      'This subsector comprises (1) legal entities engaged only in holding the securities of subsidiaries and affiliates for the purpose of owning a controlling interest or influencing the management decisions of these businesses, or (2), establishments primarily engaged in administering, overseeing, and managing other establishments of the company or enterprise and which may also hold the securities of their subsidiaries and affiliates. A characteristic of economic units in this sector is that all activities are focused on serving the economic units of the enterprise group, that is, they do not provide services to unaffiliated establishment.',
  },
  {
    code: '561',
    title: 'Administrative and support services',
    description:
      'This subsector comprises establishments primarily engaged in activities that support the day-to-day operations of other organizations. This includes activities such as administration, hiring and placing personnel, preparing documents, taking orders from clients, collecting payments for claims, arranging travel, providing security and surveillance, cleaning buildings, and packaging and labelling products. These activities are often undertaken in-house by establishments found in many sectors of the economy. The establishments of this subsector specialize in one or more of these activities and can therefore provide services to clients in a variety of industries and, in some cases, to households. The individual industries of this subsector are defined on the basis of the particular process in which they are engaged and the particular services they provide.',
  },
  {
    code: '562',
    title: 'Waste management and remediation services',
    description:
      'This subsector comprises establishments primarily engaged in providing waste management services, such as waste collection, treatment and disposal services; environmental remediation services; and septic tank pumping services. Material recovery facilities are also included.',
  },
  {
    code: '611',
    title: 'Educational services',
    description:
      "This subsector comprises establishments primarily engaged in providing instruction and training in a wide variety of subjects. This instruction and training is provided by specialized establishments, such as schools, colleges, universities and training centres. The subsector is structured according to the level and type of educational services provided. Elementary and secondary schools, community colleges, Collèges d'enseignement général et professionnel (C.E.G.E.P.s) and universities correspond to a recognized series of formal levels of education designated by diplomas, associate degrees (and equivalent certificates) and degrees. The remaining industry groups are based on the type of instruction or training offered and the levels are not always as formally defined. The establishments are often highly specialized, many offering instruction in a very limited subject matter, for example, ski lessons or one specific type of software. Within the subsector, the level and types of training that are required of the instructors and teachers vary depending on the industry.",
  },
  {
    code: '621',
    title: 'Ambulatory health care services',
    description:
      'This subsector comprises establishments primarily engaged in providing health care services, directly or indirectly, to ambulatory patients. Health practitioners in this subsector provide out-patient services, in which the facilities and equipment are not usually the most significant part of the production process.',
  },
  {
    code: '622',
    title: 'Hospitals',
    description:
      'This subsector comprises establishments, licensed as hospitals, primarily engaged in providing diagnostic and medical treatment services, and specialized accommodation services to in-patients. These establishments have an organized medical staff of physicians, nurses and other health professionals, technologists and technicians. Hospitals use specialized facilities and equipment that form a significant and integral part of the production process. Hospitals may also provide a wide variety of out-patient services as a secondary activity.',
  },
  {
    code: '623',
    title: 'Nursing and residential care facilities',
    description:
      'This subsector comprises establishments primarily engaged in providing residential care combined with either nursing, supervisory or other types of care as required by the residents. In this subsector, the facilities are a significant part of the production process and the care provided is a mix of health and social services, with the health component being largely nursing services.',
  },
  {
    code: '624',
    title: 'Social assistance',
    description:
      'This subsector comprises establishments primarily engaged in providing a wide variety of assistance services directly to their clients. These services do not include residential or accommodation services, except on a short-stay basis.',
  },
  {
    code: '711',
    title: 'Performing arts, spectator sports and related industries',
    description:
      'This subsector comprises establishments primarily engaged in producing, or organizing and promoting, live presentations that involve the performances of actors and actresses, singers, dancers, musical groups and artists, athletes and other entertainers. This subsector also includes independent (freelance) entertainers and artists and the establishments that manage their careers. The classification recognizes four basic processes: producing events; organizing and promoting events; managing and representing entertainers; and providing the artistic, creative and technical skills necessary for the production of artistic products and live performances. This subsector makes a clear distinction between performing arts companies and performing artists (independents). Although not unique to arts and entertainment, freelancing is a particularly important phenomenon in this subsector; however, it is difficult to implement in the case of musical groups (companies) and artists, especially pop groups. These establishments tend to be more loosely organized and it can be difficult to distinguish companies from freelancers. Therefore, this subsector includes one industry that covers both musical groups and musical artists.',
  },
  {
    code: '712',
    title: 'Heritage institutions',
    description:
      'This subsector comprises establishments primarily engaged in preserving and exhibiting objects, sites and natural wonders of historical, cultural and educational value.',
  },
  {
    code: '713',
    title: 'Amusement, gambling and recreation industries',
    description:
      'This subsector comprises establishments primarily engaged in operating recreation, amusement and gambling facilities and services. Examples of establishments in this subsector are golf courses, skiing facilities, marinas, recreational sports and fitness centres, bowling centres, amusement parks, amusement arcades and parlours, casinos, bingo halls, operators of video gaming terminals and operators of lotteries. There are establishments engaged in amusement, gambling and recreation activities in combination with other activities that are classified in other sectors. The most important are listed below.',
  },
  {
    code: '721',
    title: 'Accommodation services',
    description:
      'This subsector comprises establishments primarily engaged in providing short-term lodging for travellers, vacationers and others. In addition to lodging, a range of other services may be provided. For example, many establishments have restaurants, while others have recreational facilities. Lodging establishments are classified in this subsector even if the provision of complementary services generates more revenues. Establishments that operate lodging facilities primarily designed to accommodate outdoor enthusiasts, are also included in this subsector. These establishments are characterized by the type of accommodation and by the nature and the range of recreational facilities and activities provided to their clients. Establishments that manage short-stay accommodation establishments, such as hotels and motels, on a contractual basis are classified in this subsector if they provide both management and operating staff. These establishments are classified according to the type of facility they manage.',
  },
  {
    code: '722',
    title: 'Food services and drinking places',
    description:
      'This subsector comprises establishments primarily engaged in preparing meals, snacks and beverages, to customer order, for immediate consumption on and off the premises. This subsector does not include food service activities that occur within establishments such as hotels, civic and social associations, amusement and recreation parks, and theatres. However, leased food-service locations in facilities such as hotels, shopping malls, airports and department stores are included. The industry groups within this subsector reflect the level and type of service provided.',
  },
  {
    code: '811',
    title: 'Repair and maintenance',
    description:
      'This subsector comprises establishments primarily engaged in repairing and maintaining motor vehicles, machinery, equipment and other products. These establishments repair or perform general or routine maintenance on such products, to ensure they work efficiently.',
  },
  {
    code: '812',
    title: 'Personal and laundry services',
    description:
      'This subsector comprises establishments primarily engaged in providing personal care services, funeral services, laundry services and other services, such as pet care and photo finishing. Operators of parking facilities are also included.',
  },
  {
    code: '813',
    title: 'Religious, grant-making, civic, and professional and similar organizations',
    description:
      'This subsector comprises establishments primarily engaged in organizing and promoting religious activities, supporting various causes through grant-making, advocating (promoting) various social and political causes, and promoting and defending the interests of their members.',
  },
  {
    code: '814',
    title: 'Private households',
    description:
      'This subsector comprises private households engaged in employing workers, on or about the premises, in activities primarily concerned with the operation of the household. These private households may employ individuals such as cooks, maids and butlers, and outside workers, such as gardeners, caretakers and other maintenance workers. The services of individuals providing baby-sitting or nanny services are included.',
  },
  {
    code: '911',
    title: 'Federal government public administration',
    description:
      'This subsector comprises establishments of the federal government primarily engaged in activities of a governmental nature, such as legislative activities, judicial activities, taxation, national defence, public order and safety, immigration services, foreign affairs and international assistance and the administration of government programs.',
  },
  {
    code: '912',
    title: 'Provincial and territorial public administration',
    description:
      'This subsector comprises establishments of provincial or territorial governments primarily engaged in activities of a governmental nature, such as legislative activities, judicial activities, taxation, public order and safety, and the administration of provincial or territorial government programs.',
  },
  {
    code: '913',
    title: 'Local, municipal and regional public administration',
    description:
      'This subsector comprises establishments of local governments primarily engaged in activities of a governmental nature, such as legislative activities, taxation, public order and safety, and the administration of local government programs.',
  },
  {
    code: '914',
    title: 'Indigenous public administration',
    description:
      'This subsector comprises establishments of Indigenous governments primarily engaged in providing a wide variety of services to their citizens that would otherwise be provided by federal, provincial or municipal levels of governments.',
  },
  {
    code: '919',
    title: 'International and other extra-territorial public administration',
    description:
      'This subsector comprises establishments of foreign governments in Canada primarily engaged in governmental service activities, such as consular, diplomatic and legation activities.',
  },
  {
    code: '1111',
    title: 'Oilseed and grain farming',
    description:
      'This industry group comprises establishments primarily engaged in growing oilseeds and grains. Establishments primarily engaged in producing seeds are classified in the appropriate crop industry.',
  },
  {
    code: '1112',
    title: 'Vegetable and melon farming',
    description:
      'This industry group comprises establishments primarily engaged in growing vegetables and melons. Establishments primarily engaged in producing vegetable and melon seeds and vegetable and melon bedding plants are also included in this industry.',
  },
  {
    code: '1113',
    title: 'Fruit and tree nut farming',
    description: 'This industry group comprises establishments primarily engaged in growing fruit and nuts.',
  },
  {
    code: '1114',
    title: 'Greenhouse, nursery and floriculture production',
    description:
      'This industry group comprises establishments primarily engaged in growing crops of any kind under cover, growing nursery crops and growing flowers. Under cover includes in greenhouses, cold frames, cloth houses, and lath houses. The crops grown are removed at various stages of maturity.',
  },
  {
    code: '1119',
    title: 'Other crop farming',
    description:
      'This industry group comprises establishments, not classified to any other industry group, primarily engaged in growing crops, such as tobacco, peanuts, sugar beets, cotton, sugar-cane, hay, agave, herbs and spices, mint, hops, and hay and grass seeds. Combination crop farming and the gathering of maple sap are included in this industry group.',
  },
  {
    code: '1121',
    title: 'Cattle ranching and farming',
    description:
      'This industry group comprises establishments primarily engaged in raising, milking and fattening cattle.',
  },
  {
    code: '1122',
    title: 'Hog and pig farming',
    description: 'This industry group comprises establishments primarily engaged in raising hogs and pigs.',
  },
  {
    code: '1123',
    title: 'Poultry and egg production',
    description:
      'This industry group comprises establishments primarily engaged in breeding, hatching and raising poultry for meat or egg production.',
  },
  {
    code: '1124',
    title: 'Sheep and goat farming',
    description:
      'This industry group comprises establishments primarily engaged in raising sheep and goats, and feeding or fattening lambs.',
  },
  {
    code: '1125',
    title: 'Aquaculture',
    description:
      'This industry group comprises establishments primarily engaged in farm-raising aquatic animals and plants. Establishments primarily engaged in raising both aquatic animals and plants in integrated growing operations, aquaponics, are also included. These activities can occur both in natural waters and in artificial aquatic impoundments and include the use of some form of intervention in the rearing or growing process to enhance production.',
  },
  {
    code: '1129',
    title: 'Other animal production',
    description:
      'This industry group comprises establishments, not classified to any other industry group, primarily engaged in raising animals, such as bees, horses and other equines, rabbits and other fur-bearing animals, llamas, deer, worms, crickets, laboratory animals and companion animals, for example dogs, cats, pet birds and other pets. The production of animal products, such as honey and other bee products, are also included. Establishments primarily engaged in raising a combination of animals, with no one predominating, are also included in this industry group.',
  },
  {
    code: '1131',
    title: 'Timber tract operations',
    description:
      'This industry group comprises establishments primarily engaged in the operation of timber tracts, for the purpose of selling standing timber.',
  },
  {
    code: '1132',
    title: 'Forest nurseries and gathering of forest products',
    description:
      'This industry group comprises establishments with two different production processes, those primarily engaged in growing trees for the purpose of reforestation, and those primarily engaged in gathering forest products.',
  },
  {
    code: '1133',
    title: 'Logging',
    description:
      'This industry group comprises establishments primarily engaged in cutting timber, producing rough, round, hewn, or riven primary wood, and producing wood chips in the forest. Establishments primarily engaged in cutting and transporting timber are also included in this industry.',
  },
  {
    code: '1141',
    title: 'Fishing',
    description:
      'This industry group comprises establishments primarily engaged in the commercial catching or taking of finfish, shellfish, and other marine animals from their natural habitats.',
  },
  {
    code: '1142',
    title: 'Hunting and trapping',
    description:
      'This industry group comprises establishments primarily engaged in commercial hunting and trapping, and operating and managing commercial game preserves.',
  },
  {
    code: '1151',
    title: 'Support activities for crop production',
    description:
      'This industry group comprises establishments primarily engaged in providing support activities for growing crops.',
  },
  {
    code: '1152',
    title: 'Support activities for animal production',
    description:
      'This industry group comprises establishments primarily engaged in providing support activities related to raising livestock, including companion animals.',
  },
  {
    code: '1153',
    title: 'Support activities for forestry',
    description:
      'This industry group comprises establishments primarily engaged in performing particular support activities, related to harvesting timber.',
  },
  {
    code: '2111',
    title: 'Oil and gas extraction',
    description:
      'This industry group comprises establishments primarily engaged in operating oil and gas field properties. Such activities may include exploration for crude petroleum and natural gas; drilling, completing and equipping wells; operating separators, emulsion breakers, desilting equipment and field gathering lines for crude petroleum; and all other activities in the preparation of oil and gas up to the point of shipment from the producing property. This subsector includes the production of oil, the mining and extraction of oil from oil shale and oil sands, and the production of gas and hydrocarbon liquids, through gasification, liquefaction and pyrolysis of coal at the mine site.',
  },
  {
    code: '2121',
    title: 'Coal mining',
    description:
      'This industry group comprises establishments primarily engaged in mining bituminous and lignite coal by underground mining, and auger mining, strip mining, culm bank mining and other surface mining. Mining operations and preparation plants (also known as cleaning plants and washeries), whether or not such plants are operated in conjunction with mine sites, are included.',
  },
  {
    code: '2122',
    title: 'Metal ore mining',
    description:
      'This industry group comprises establishments primarily engaged in mining metallic minerals (ores). Also included are establishments engaged in ore dressing and beneficiating operations, whether performed at mills operated in conjunction with the mines served or at mills, such as custom mills, operated separately. These include mills that crush, grind, wash, dry, sinter, calcine or leach ore, or perform gravity separation or flotation operations.',
  },
  {
    code: '2123',
    title: 'Non-metallic mineral mining and quarrying',
    description:
      'This industry group comprises establishments primarily engaged in mining or quarrying non-metallic minerals, except coal. Primary preparation plants, such as those engaged in crushing, grinding and washing, are included.',
  },
  {
    code: '2131',
    title: 'Support activities for mining, and oil and gas extraction',
    description:
      'This industry group comprises establishments primarily engaged in providing support services, on a contract or fee basis, for the mining and quarrying of minerals and for the extraction of oil and gas. Establishments engaged in the exploration for minerals, other than oil or gas, are included. Exploration includes traditional prospecting methods, such as taking ore samples and making geological observations at prospective sites.',
  },
  {
    code: '2211',
    title: 'Electric power generation, transmission and distribution',
    description:
      'This industry group comprises establishments primarily engaged in the generation of bulk electric power, transmission from generating facilities to distribution centres, and/or distribution to end users.',
  },
  {
    code: '2212',
    title: 'Natural gas distribution',
    description:
      'This industry group comprises establishments primarily engaged in the distribution of natural or synthetic gas to the ultimate consumers through a system of mains. Gas marketers or brokers, that arrange the sale of natural gas over distribution systems operated by others, are included.',
  },
  {
    code: '2213',
    title: 'Water, sewage and other systems',
    description:
      'This industry group comprises establishments primarily engaged in operating water, sewage and related systems.',
  },
  {
    code: '2361',
    title: 'Residential building construction',
    description:
      'This industry group comprises establishments primarily engaged in the construction or remodelling and renovation of single-family and multi-family residential buildings. Included in this industry group are residential housing general contractors, operative builders and remodellers of residential structures, residential project construction management firms, and residential design-build firms.',
  },
  {
    code: '2362',
    title: 'Non-residential building construction',
    description:
      'This industry group comprises establishments primarily engaged in the construction (including new work, additions and major alterations) of industrial, commercial and institutional buildings. This industry group includes non-residential general contractors, non-residential operative builders, non-residential design-build firms, and non-residential construction management firms.',
  },
  {
    code: '2371',
    title: 'Utility system construction',
    description:
      'This industry group comprises establishments primarily engaged in the construction of distribution lines and related buildings and structures for utilities (i.e., water, sewer, petroleum, gas, power, and communication). All structures (including buildings) that are integral parts of utility systems (e.g., storage tanks, pumping stations, power plants, and refineries) are included in this industry group.',
  },
  {
    code: '2372',
    title: 'Land subdivision',
    description:
      'This industry group comprises establishments primarily engaged in servicing land and subdividing real property into lots, for subsequent sale to builders. Land subdivision precedes any building activity and may create residential lots, commercial tracts or industrial parks. Servicing of land may include land clearing and excavation work for the installation of roads and utility lines. The extent of the work may vary from project to project and establishments may perform all the work themselves or subcontract it out. Establishments that perform only the legal subdivision of land are not included in this industry group.',
  },
  {
    code: '2373',
    title: 'Highway, street and bridge construction',
    description:
      'This industry group comprises establishments primarily engaged in the construction of highways (including elevated), streets, roads, airport runways, public sidewalks, or bridges. The work performed may include new work, reconstruction, rehabilitation, and repairs. Specialized trade activities related to highway, street, and bridge construction (e.g., installing guardrails on highways) are included.',
  },
  {
    code: '2379',
    title: 'Other heavy and civil engineering construction',
    description:
      'This industry group comprises establishments, not classified to any other industry group, primarily engaged in constructing heavy and civil engineering works. The work performed may include new work, reconstruction, rehabilitation, and repairs. Specialized trade activities related to these civil engineering construction projects (such as marine pile driving) are included. Construction projects involving water resources (e.g., dredging and land drainage), development of marine facilities, and open space recreational construction projects (e.g., parks and trails) are included in this industry.',
  },
  {
    code: '2381',
    title: 'Foundation, structure, and building exterior contractors',
    description:
      'This industry group comprises establishments primarily engaged in the specialty trades needed to complete the basic structure (i.e., foundation, frame, and shell) of buildings. The work performed may include new work, additions, alterations, maintenance, and repairs.',
  },
  {
    code: '2382',
    title: 'Building equipment contractors',
    description:
      'This industry group comprises establishments primarily engaged in installing or servicing equipment that forms part of a building mechanical system (e.g., electricity, water, heating, and cooling). The work performed may include new work, additions, alterations, or maintenance and repairs. Contractors installing specialized building equipment, such as elevators, escalators, service station equipment, and central vacuum cleaning systems are also included.',
  },
  {
    code: '2383',
    title: 'Building finishing contractors',
    description:
      'This industry group comprises establishments primarily engaged in the specialty trades needed to finish buildings. The work performed may include new work, additions, alterations, or maintenance and repairs.',
  },
  {
    code: '2389',
    title: 'Other specialty trade contractors',
    description:
      'This industry group comprises establishments, not classified to any other industry group, primarily engaged in site preparation activities and other specialized trade activities such as crane rental with operator, fence installation, sandblasting building exteriors and steeplejack work. The work performed may include new work, additions, alterations, maintenance, and repairs.',
  },
  {
    code: '3111',
    title: 'Animal food manufacturing',
    description:
      'This industry group comprises establishments primarily engaged in manufacturing food and feed for animals, including pets.',
  },
  {
    code: '3112',
    title: 'Grain and oilseed milling',
    description:
      'This industry group comprises establishments primarily engaged in milling grains and oilseeds; refining and blending fats and oils; and making breakfast cereal products.',
  },
  {
    code: '3113',
    title: 'Sugar and confectionery product manufacturing',
    description:
      'This industry group comprises establishments primarily engaged in manufacturing sugar and confectionery products.',
  },
  {
    code: '3114',
    title: 'Fruit and vegetable preserving and specialty food manufacturing',
    description:
      'This industry group comprises establishments primarily engaged in manufacturing frozen fruits and vegetables; frozen entrées and side dishes of several ingredients, except seafood; and fruits and vegetables preserved by pickling, canning, dehydrating and similar processes.',
  },
  {
    code: '3115',
    title: 'Dairy product manufacturing',
    description:
      'This industry group comprises establishments primarily engaged in manufacturing dairy products. Establishments primarily engaged in manufacturing substitute products are included.',
  },
  {
    code: '3116',
    title: 'Meat product manufacturing',
    description: 'This industry group comprises establishments primarily engaged in manufacturing meat products.',
  },
  {
    code: '3117',
    title: 'Seafood product preparation and packaging',
    description:
      'This industry group comprises establishments primarily engaged in canning seafood, including soup; smoking, salting and drying seafood; preparing fresh fish by removing heads, fins, scales, bones and entrails; shucking and packing fresh shellfish; processing marine fats and oils; and freezing seafood. Establishments known as floating factory ships, that are engaged in shipboard processing of seafood, are included.',
  },
  {
    code: '3118',
    title: 'Bakeries and tortilla manufacturing',
    description:
      'This industry group comprises establishments engaged in manufacturing baked goods from flour, not from prepared doughs. Establishments primarily engaged in manufacturing bakery products from flour, for sale to the general public, intended for consumption off the premises, are also included.',
  },
  {
    code: '3119',
    title: 'Other food manufacturing',
    description:
      'This industry group comprises establishments, not classified to any other industry group, primarily engaged in manufacturing food.',
  },
  {
    code: '3121',
    title: 'Beverage manufacturing',
    description: 'This industry group comprises establishments primarily engaged in manufacturing beverages.',
  },
  {
    code: '3122',
    title: 'Tobacco manufacturing',
    description: 'This industry group comprises establishments primarily engaged in manufacturing tobacco products.',
  },
  {
    code: '3123',
    title: 'Cannabis product manufacturing',
    description:
      'This industry group comprises establishments primarily engaged in manufacturing products made from cannabis plants with a level of tetrahydrocannabinol (THC) greater than 0.3%.',
  },
  {
    code: '3131',
    title: 'Fibre, yarn and thread mills',
    description:
      'This industry group comprises establishments primarily engaged in spinning yarn from fibres; texturing, throwing or twisting man-made fibre filaments or purchased yarns; or manufacturing thread for sewing, crocheting, embroidery, tatting and similar uses.',
  },
  {
    code: '3132',
    title: 'Fabric mills',
    description:
      'This industry group comprises establishments primarily engaged in manufacturing textile fabrics. Establishments classified in this industry group may finish the fabrics that they manufacture. Establishments primarily engaged in manufacturing both fabrics and textile products, except knitted clothing, are included.',
  },
  {
    code: '3133',
    title: 'Textile and fabric finishing and fabric coating',
    description:
      'This industry group comprises establishments primarily engaged in preparing and finishing yarn and thread, textile fabrics, textile products (except carpets and rugs), and clothing; and manufacturing coated or laminated fabrics.',
  },
  {
    code: '3141',
    title: 'Textile furnishings mills',
    description:
      'This industry group comprises establishments primarily engaged in manufacturing carpets and rugs, and curtains and linens.',
  },
  {
    code: '3149',
    title: 'Other textile product mills',
    description:
      'This industry group comprises establishments, not classified to any other industry group, primarily engaged in manufacturing textile products.',
  },
  {
    code: '3151',
    title: 'Apparel knitting mills',
    description:
      'This industry group comprises establishments primarily engaged in knitting clothing from yarn; or manufacturing clothing from knit fabrics made in the same establishment. Establishments classified in this industry group may finish the clothing that they knit.',
  },
  {
    code: '3152',
    title: 'Cut and sew clothing manufacturing',
    description:
      'This industry group comprises establishments primarily engaged in manufacturing clothing from fabric made in other establishments.',
  },
  {
    code: '3159',
    title: 'Clothing accessories and other clothing manufacturing',
    description:
      'This industry group comprises establishments, not classified to any other industry group, primarily engaged in manufacturing clothing or clothing accessories.',
  },
  {
    code: '3161',
    title: 'Leather and hide tanning and finishing',
    description:
      'This industry group comprises establishments primarily engaged in tanning, currying, colouring and finishing hides and skins into leather. Leather converters, who buy hides and skins and have them processed into leather by others, on a contract basis, are included. Establishments primarily engaged in dressing and dyeing fur are also included.',
  },
  {
    code: '3162',
    title: 'Footwear manufacturing',
    description:
      'This industry group comprises establishments primarily engaged in manufacturing footwear, of any material.',
  },
  {
    code: '3169',
    title: 'Other leather and allied product manufacturing',
    description:
      'This industry group comprises establishments, not classified to any other industry group, primarily engaged in manufacturing leather and allied products. Some important products of this industry are luggage, handbags, purses, and small articles normally carried on the person or in a handbag, such as billfolds, key cases and coin purses of leather or other materials, except precious metal.',
  },
  {
    code: '3211',
    title: 'Sawmills and wood preservation',
    description:
      'This industry group comprises establishments primarily engaged in manufacturing boards, dimension lumber, timber, poles and ties from logs and bolts. These establishments produce lumber that may be rough, or dressed by a planing machine to achieve smoothness and uniformity of size, but is generally not further worked or shaped. Establishments that preserve wood are also included.',
  },
  {
    code: '3212',
    title: 'Veneer, plywood and engineered wood product manufacturing',
    description:
      'This industry group comprises establishments primarily engaged in manufacturing softwood and hardwood veneer and plywood; structural wood members, except lumber; and reconstituted wood panel products. Veneer is produced as a thin sheet of wood of uniform thickness by peeling or slicing logs. Plywood is produced by gluing and compressing together, three or more sheets of veneer, with the grain of alternate sheets usually laid crosswise. Structural wood members are made by laminating, joining and assembling wood components according to specified engineering design criteria. Reconstituted wood panel products are produced by processes involving pressure, adhesives and binders. The laminated products produced in this industry may have layers of materials other than wood.',
  },
  {
    code: '3219',
    title: 'Other wood product manufacturing',
    description:
      'This industry group comprises establishments, not classified to any other industry group, primarily engaged in manufacturing wood products.',
  },
  {
    code: '3221',
    title: 'Pulp, paper and paperboard mills',
    description:
      'This industry group comprises establishments primarily engaged in manufacturing pulp, paper or paperboard. Establishments that manufacture pulp, paper or paperboard, either alone or in combination with paper converting, are included.',
  },
  {
    code: '3222',
    title: 'Converted paper product manufacturing',
    description:
      'This industry group comprises establishments primarily engaged in manufacturing paper products from purchased paper and paperboard.',
  },
  {
    code: '3231',
    title: 'Printing and related support activities',
    description:
      'This industry group comprises establishments primarily engaged in printing and providing related support activities.',
  },
  {
    code: '3241',
    title: 'Petroleum and coal product manufacturing',
    description:
      'This industry group comprises establishments primarily engaged in transforming crude petroleum and coal into intermediate and end products. The dominant process is petroleum refining, which separates crude petroleum into components or fractions through such techniques as cracking and distillation.',
  },
  {
    code: '3251',
    title: 'Basic chemical manufacturing',
    description:
      'This industry group comprises establishments primarily engaged in manufacturing chemicals, using basic processes such as thermal cracking and distillation. Chemicals produced in this industry group are usually separate chemical elements or separate chemically-defined compounds.',
  },
  {
    code: '3252',
    title: 'Resin, synthetic rubber, and artificial and synthetic fibres and filaments manufacturing',
    description:
      'This industry group comprises establishments primarily engaged in manufacturing polymers such as resins, synthetic rubber, and textile fibres and filaments. Polymerization of monomers into polymers, for example of styrene into polystyrene, is the basic process.',
  },
  {
    code: '3253',
    title: 'Pesticide, fertilizer and other agricultural chemical manufacturing',
    description:
      'This industry group comprises establishments primarily engaged in manufacturing agricultural chemicals, including nitrogenous and phosphoric fertilizer materials; mixed fertilizers; and agricultural and household pest control chemicals.',
  },
  {
    code: '3254',
    title: 'Pharmaceutical and medicine manufacturing',
    description:
      'This industry group comprises establishments primarily engaged in manufacturing drugs, medicines and related products for human or animal use. Establishments in this industry may undertake one or more of several processes, including basic processes, such as chemical synthesis, fermentation, distillation and solvent extraction; grading, grinding and milling; and packaging in forms suitable for internal and external use, such as tablets, vials, ampoules and ointments.',
  },
  {
    code: '3255',
    title: 'Paint, coating and adhesive manufacturing',
    description:
      'This industry group comprises establishments primarily engaged in manufacturing paints, coatings and adhesives.',
  },
  {
    code: '3256',
    title: 'Soap, cleaning compound and toilet preparation manufacturing',
    description:
      'This industry group comprises establishments primarily engaged in manufacturing soap and other cleaning compounds and toilet preparations.',
  },
  {
    code: '3259',
    title: 'Other chemical product manufacturing',
    description:
      'This industry group comprises establishments, not classified to any other industry group, primarily engaged in manufacturing chemical products.',
  },
  {
    code: '3261',
    title: 'Plastic product manufacturing',
    description:
      'This industry group comprises establishments primarily engaged in manufacturing intermediate or final products from plastics resins, using such processes as compression moulding, extrusion moulding, injection moulding, blow moulding and casting. The production process in most of these industries is such that a wide variety of products can be produced. The plastics resins used by these establishments may be new or recycled.',
  },
  {
    code: '3262',
    title: 'Rubber product manufacturing',
    description:
      'This industry group comprises establishments primarily engaged in processing natural, synthetic or reclaimed rubber materials into intermediate or final products using such processes as vulcanizing, cementing, moulding, extruding and lathe-cutting.',
  },
  {
    code: '3271',
    title: 'Clay product and refractory manufacturing',
    description:
      'This industry group comprises establishments primarily engaged in manufacturing pottery, ceramic and structural clay products.',
  },
  {
    code: '3272',
    title: 'Glass and glass product manufacturing',
    description:
      'This industry group comprises establishments primarily engaged in manufacturing glass and glass products.',
  },
  {
    code: '3273',
    title: 'Cement and concrete product manufacturing',
    description:
      'This industry group comprises establishments primarily engaged in manufacturing hydraulic cement, ready-mix concrete, concrete bricks, pipes and blocks, and other concrete products.',
  },
  {
    code: '3274',
    title: 'Lime and gypsum product manufacturing',
    description:
      'This industry group comprises establishments primarily engaged in manufacturing lime and gypsum products.',
  },
  {
    code: '3279',
    title: 'Other non-metallic mineral product manufacturing',
    description:
      'This industry group comprises establishments, not classified to any other industry group, primarily engaged in manufacturing non-metallic mineral products.',
  },
  {
    code: '3311',
    title: 'Iron and steel mills and ferro-alloy manufacturing',
    description:
      'This industry group comprises establishments primarily engaged in smelting iron ore and steel scrap to produce pig iron in molten or solid form; converting pig iron into steel by the removal, through combustion in furnaces, of the carbon in the iron. These establishments may cast ingots only, or also produce iron and steel basic shapes, such as plates, sheets, strips, rods and bars, and other fabricated products. Electric arc furnace mini-mills are included. Establishments primarily engaged in producing ferro-alloys are also included.',
  },
  {
    code: '3312',
    title: 'Steel product manufacturing from purchased steel',
    description:
      'This industry group comprises establishments primarily engaged in manufacturing iron and steel pipe and tube, drawing steel wire, and rolling steel shapes, from purchased steel.',
  },
  {
    code: '3313',
    title: 'Alumina and aluminum production and processing',
    description:
      'This industry group comprises establishments primarily engaged in extracting alumina generally from bauxite ore; producing aluminum from alumina; refining aluminum by any process; and rolling, drawing, casting, extruding and alloying aluminum and aluminum-based alloy basic shapes.',
  },
  {
    code: '3314',
    title: 'Non-ferrous metal (except aluminum) production and processing',
    description:
      'This industry group comprises establishments primarily engaged in smelting, refining, rolling, drawing, extruding and alloying non-ferrous metal, except aluminum.',
  },
  {
    code: '3315',
    title: 'Foundries',
    description:
      'This industry group comprises establishments primarily engaged in pouring molten metal into moulds or dies to form castings.',
  },
  {
    code: '3321',
    title: 'Forging and stamping',
    description:
      'This industry group comprises establishments primarily engaged in shaping hot metal by forging to produce a part near its final size and shape; or pressing and cutting sheet metal stock to form stampings. These establishments generally operate on a job or order basis, manufacturing metal stampings or forgings for sale to others or for inter-plant transfer. These establishments may surface-finish the forgings and stampings produced, by such activities as deburring and grinding, but they do not further process them.',
  },
  {
    code: '3322',
    title: 'Cutlery and hand tool manufacturing',
    description:
      'This industry group comprises establishments primarily engaged in manufacturing non-precious and precious plated cutlery and flatware. Establishments primarily engaged in manufacturing files and other hand and edge tools for metalworking, woodworking and general maintenance are included.',
  },
  {
    code: '3323',
    title: 'Architectural and structural metals manufacturing',
    description:
      'This industry group comprises establishments primarily engaged in fabricating metal products for structural or architectural purposes.',
  },
  {
    code: '3324',
    title: 'Boiler, tank and shipping container manufacturing',
    description:
      'This industry group comprises establishments primarily engaged in cutting, forming and joining metal to manufacture products, such as power boilers, heat exchangers and tanks of heavy gauge metal, and cans, boxes and other light gauge metal containers.',
  },
  {
    code: '3325',
    title: 'Hardware manufacturing',
    description: 'This industry group comprises establishments primarily engaged in manufacturing metal hardware.',
  },
  {
    code: '3326',
    title: 'Spring and wire product manufacturing',
    description:
      'This industry group comprises establishments primarily engaged in manufacturing wire products made from purchased wire.',
  },
  {
    code: '3327',
    title: 'Machine shops, turned product, and screw, nut and bolt manufacturing',
    description:
      'This industry group comprises establishments primarily engaged in operating machine shops, which use machine tools, such as lathes and automatic screw machines, for turning, boring, threading or otherwise shaping metal, to manufacture parts, other than complete machines, for the trade. Shops that set up to do production runs of industrial fasteners, such as bolts, nuts and screws, are included.',
  },
  {
    code: '3328',
    title: 'Coating, engraving, cold and heat treating and allied activities',
    description:
      'This industry group comprises establishments primarily engaged in coating, engraving, heat treating and similarly processing metal. These activities often involve heating the metal, and the purpose is often to harden it. In general, the hardening of metal is included. Other activities of this industry group include tempering, brazing, plating (including electroplating and re-chroming), polishing, sand-blasting and colouring metal and metal products. Establishments that perform these processes on other materials, such as plastics, in addition to metals, as well as establishments primarily engaged in plating with precious metal for the trade are included.',
  },
  {
    code: '3329',
    title: 'Other fabricated metal product manufacturing',
    description:
      'This industry group comprises establishments, not classified to any other industry group, primarily engaged in fabricating metal products.',
  },
  {
    code: '3331',
    title: 'Agricultural, construction and mining machinery manufacturing',
    description:
      'This industry group comprises establishments primarily engaged in manufacturing machinery designed for use in the agriculture, construction and mining industries.',
  },
  {
    code: '3332',
    title: 'Industrial machinery manufacturing',
    description:
      'This industry group comprises establishments primarily engaged in manufacturing machinery designed for use in specific manufacturing industries.',
  },
  {
    code: '3333',
    title: 'Commercial and service industry machinery manufacturing',
    description:
      'This industry group comprises establishments primarily engaged in manufacturing machinery for use in commercial and service industries.',
  },
  {
    code: '3334',
    title: 'Ventilation, heating, air-conditioning and commercial refrigeration equipment manufacturing',
    description:
      'This industry group comprises establishments primarily engaged in manufacturing ventilation, heating, air-conditioning and commercial refrigeration equipment.',
  },
  {
    code: '3335',
    title: 'Metalworking machinery manufacturing',
    description:
      'This industry group comprises establishments primarily engaged in manufacturing metal cutting and forming machine tools (except hand tools), and related products. The machine tools included in this industry are those not supported in the hands of an operator when in use. Establishments primarily engaged in manufacturing industrial moulds; tools, dies, jigs and fixtures; machine tool accessories and attachments; and rolls are included.',
  },
  {
    code: '3336',
    title: 'Engine, turbine and power transmission equipment manufacturing',
    description:
      'This industry group comprises establishments primarily engaged in manufacturing turbines and turbine generator sets; internal combustion engines (except automotive gasoline and aircraft); and speed changers, industrial high-speed drives and gears. Establishments primarily engaged in manufacturing wind- and solar-powered turbine generators and windmills for generating electric power are included.',
  },
  {
    code: '3339',
    title: 'Other general-purpose machinery manufacturing',
    description:
      'This industry group comprises establishments, not classified to any other industry group, primarily engaged in manufacturing machinery that is not designed for use in any specific industry.',
  },
  {
    code: '3341',
    title: 'Computer and peripheral equipment manufacturing',
    description:
      "This industry group comprises establishments primarily engaged in manufacturing computers and computer peripheral equipment. Computers can be digital, analogue or hybrid. Digital computers, the most common type, are devices that can do all of the following: (1) store the processing program or programs and the data immediately necessary for the execution of the program; (2) be freely programmed in accordance with the requirements of the user; (3) perform arithmetical computations specified by the user; and (4) execute, without human intervention, a processing program that requires the computer to modify its execution, by logical decision, during the processing run. Analogue computers are capable of simulating mathematical models and comprise, at least, analogue, control and programming elements. Peripherals are assemblies of components that are self-contained, but designed for use with computers. For purposes of classification, a peripheral must consist of more than a loaded circuit board. Peripheral equipment may be installed inside or outside the computer's housing. Important types of peripheral equipment are input-output devices, such as monitors, keyboards, mice and joysticks; storage devices, such as disk drives and CD-ROM readers; and printers. Dumb computer terminals, automated teller machines (ATM's), point-of-sale (POS) terminals and bar code scanners are treated as peripheral equipment. Computers and peripheral equipment may be sold complete or in kits to be assembled by the purchaser.",
  },
  {
    code: '3342',
    title: 'Communications equipment manufacturing',
    description:
      'This industry group comprises establishments primarily engaged in manufacturing equipment used to move signals electronically over wires or through the air, such as telephone apparatus, radio and television broadcast equipment, and satellite communications equipment.',
  },
  {
    code: '3343',
    title: 'Audio and video equipment manufacturing',
    description:
      'This industry group comprises establishments primarily engaged in manufacturing electronic audio and video equipment.',
  },
  {
    code: '3344',
    title: 'Semiconductor and other electronic component manufacturing',
    description:
      'This industry group comprises establishments primarily engaged in manufacturing semiconductors and other electronic components. The following activities involving printed circuit boards are undertaken in this industry group: the production of the laminate material; the manufacture of the bare (rigid or flexible) printed circuit boards without mounted electronic components; and the loading of electronic components onto the boards.',
  },
  {
    code: '3345',
    title: 'Navigational, measuring, medical and control instruments manufacturing',
    description:
      'This industry group comprises establishments primarily engaged in manufacturing navigational, measuring, medical and controlling devices.',
  },
  {
    code: '3346',
    title: 'Manufacturing and reproducing magnetic and optical media',
    description:
      'This industry group comprises establishments primarily engaged in manufacturing magnetic and optical media, and the mass reproduction of recordings on such media. The media include audio and video tapes, diskettes, hard disk media and CD-ROMs. The products of the industry are blank media; and software (shrink-wrapped), audio, video, and multimedia products recorded on these media.',
  },
  {
    code: '3351',
    title: 'Electric lighting equipment manufacturing',
    description:
      'This industry group comprises establishments primarily engaged in manufacturing electric lamp bulbs and tubes and lighting fixtures.',
  },
  {
    code: '3352',
    title: 'Household appliance manufacturing',
    description:
      'This industry group comprises establishments primarily engaged in manufacturing kitchen, bathroom and other household appliances.',
  },
  {
    code: '3353',
    title: 'Electrical equipment manufacturing',
    description:
      'This industry group comprises establishments primarily engaged in manufacturing equipment that generates and distributes electrical power.',
  },
  {
    code: '3359',
    title: 'Other electrical equipment and component manufacturing',
    description:
      'This industry group comprises establishments, not classified to any other industry group, primarily engaged in manufacturing electrical power storage and transmission devices, and accessories for carrying current.',
  },
  {
    code: '3361',
    title: 'Motor vehicle manufacturing',
    description:
      'This industry group comprises establishments primarily engaged in manufacturing motor vehicles. Establishments that manufacture chassis and then assemble complete motor vehicles (including truck cab and chassis assemblies) and those that only manufacture motor vehicle chassis are both classified in this industry group.',
  },
  {
    code: '3362',
    title: 'Motor vehicle body and trailer manufacturing',
    description:
      'This industry group comprises establishments primarily engaged in manufacturing motor vehicle bodies and cabs, truck trailers and non-commercial trailers. The bodies and cabs may be sold as such, or assembled on purchased chassis.',
  },
  {
    code: '3363',
    title: 'Motor vehicle parts manufacturing',
    description:
      'This industry group comprises establishments primarily engaged in manufacturing motor vehicle parts, including engines. Establishments that rebuild motor vehicle parts are included in this industry group, in the same industry as the manufacture of new parts.',
  },
  {
    code: '3364',
    title: 'Aerospace product and parts manufacturing',
    description:
      'This industry group comprises establishments primarily engaged in manufacturing aircraft, missiles, space vehicles and their engines, propulsion units, auxiliary equipment, and parts thereof. The development and production of prototypes is classified in this industry, as is the factory overhaul and conversion of aircraft and propulsion systems.',
  },
  {
    code: '3365',
    title: 'Railroad rolling stock manufacturing',
    description:
      'This industry group comprises establishments primarily engaged in manufacturing and rebuilding locomotives and railroad cars, of any type or gauge, including frames and parts. The manufacture of rapid transit cars and special-purpose self-propelled railroad equipment, such as rail layers, ballast distributors, rail-tamping equipment and other railway track maintenance equipment is included in this industry group.',
  },
  {
    code: '3366',
    title: 'Ship and boat building',
    description:
      'This industry group comprises establishments primarily engaged in operating a shipyard or manufacturing boats. Shipyards are fixed facilities with dry docks and fabrication equipment capable of building a ship, defined as water-craft suitable or intended for other than personal or recreational use. Boats are defined as water-craft suitable or intended for personal or recreational use. The activities of shipyards include the construction of ships, their repair, conversion and alteration, the production of prefabricated ship sections and barge sections, and specialized services, such as ship scaling, when performed at the shipyard.',
  },
  {
    code: '3369',
    title: 'Other transportation equipment manufacturing',
    description:
      'This industry group comprises establishments, not classified to any other industry group, primarily engaged in manufacturing transportation equipment and parts.',
  },
  {
    code: '3371',
    title: 'Household and institutional furniture and kitchen cabinet manufacturing',
    description:
      'This industry group comprises establishments primarily engaged in manufacturing furniture designed for use in households; institutions such as schools, churches, restaurants and other public buildings; and wood kitchen cabinets, bathroom vanities, and counters.',
  },
  {
    code: '3372',
    title: 'Office furniture (including fixtures) manufacturing',
    description:
      'This industry group comprises establishments primarily engaged in manufacturing furniture designed for office use, such as office chairs and desks; and office and store fixtures, such as showcases. Establishments primarily engaged in manufacturing furniture parts and frames, for all types of furniture, are also included.',
  },
  {
    code: '3379',
    title: 'Other furniture-related product manufacturing',
    description:
      'This industry group comprises establishments, not classified to any other industry group, primarily engaged in manufacturing furniture-related products.',
  },
  {
    code: '3391',
    title: 'Medical equipment and supplies manufacturing',
    description:
      'This industry group comprises establishments primarily engaged in manufacturing medical equipment and supplies. Establishments primarily engaged in grinding eyeglasses and hard contact lenses to prescription, on a factory basis, are included.',
  },
  {
    code: '3399',
    title: 'Other miscellaneous manufacturing',
    description:
      'This industry group comprises establishments, not classified to any other industry group, primarily engaged in manufacturing activities.',
  },
  {
    code: '4111',
    title: 'Farm product merchant wholesalers',
    description:
      'This industry group comprises establishments primarily engaged in wholesaling livestock, grain and other farm products.',
  },
  {
    code: '4121',
    title: 'Petroleum, petroleum products, and other hydrocarbons merchant wholesalers',
    description:
      'This industry group comprises establishments primarily engaged in wholesaling crude oil, liquefied petroleum gases, heating oil and other refined petroleum products and hydrocarbons.',
  },
  {
    code: '4131',
    title: 'Food merchant wholesalers',
    description:
      'This industry group comprises establishments primarily engaged in wholesaling processed milk and other dairy products, poultry and eggs, fish and seafood products, fresh fruit and vegetables, red meat and meat products, bread and other bakery products, processed rice, flour, flour mixes, prepared cereal foods and spices.',
  },
  {
    code: '4132',
    title: 'Beverage merchant wholesalers',
    description:
      'This industry group comprises establishments primarily engaged in wholesaling alcoholic and non-alcoholic beverages.',
  },
  {
    code: '4133',
    title: 'Cigarette and tobacco product merchant wholesalers',
    description:
      'This industry group comprises establishments primarily engaged in wholesaling cured tobacco and tobacco products.',
  },
  {
    code: '4134',
    title: 'Cannabis merchant wholesalers',
    description:
      'This industry group comprises merchant wholesalers primarily engaged in wholesaling crude, unprocessed cannabis and cannabis products.',
  },
  {
    code: '4141',
    title: 'Textile, clothing and footwear merchant wholesalers',
    description:
      'This industry group comprises establishments primarily engaged in wholesaling textiles, clothing, clothing accessories, footwear, piece goods, notions and other dry goods.',
  },
  {
    code: '4142',
    title: 'Home entertainment equipment and household appliance merchant wholesalers',
    description:
      'This industry group comprises establishments primarily engaged in wholesaling home entertainment equipment and household electrical and electronic appliances and parts.',
  },
  {
    code: '4143',
    title: 'Home furnishings merchant wholesalers',
    description:
      'This industry group comprises establishments primarily engaged in wholesaling home furnishings, such as furniture, china, glassware, crockery and pottery, floor coverings, linens and draperies.',
  },
  {
    code: '4144',
    title: 'Personal goods merchant wholesalers',
    description:
      'This industry group comprises establishments primarily engaged in wholesaling personal articles, such as jewellery, watches, books, periodicals, newspapers, photographic equipment and supplies, sound recordings, video recordings, toys, hobby goods, and amusement and sporting goods.',
  },
  {
    code: '4145',
    title: 'Pharmaceuticals, toiletries, cosmetics and sundries merchant wholesalers',
    description:
      "This industry group comprises establishments primarily engaged in wholesaling proprietary and patent medicines, cosmetics, toiletries and druggists' sundries.",
  },
  {
    code: '4151',
    title: 'Motor vehicle merchant wholesalers',
    description:
      'This industry group comprises establishments primarily engaged in wholesaling new and used automobiles, trucks, truck trailers, buses and recreational vehicles.',
  },
  {
    code: '4152',
    title: 'New motor vehicle parts and accessories merchant wholesalers',
    description:
      'This industry group comprises establishments primarily engaged in wholesaling new and rebuilt motor vehicle parts and accessories.',
  },
  {
    code: '4153',
    title: 'Used motor vehicle parts and accessories merchant wholesalers',
    description:
      'This industry group comprises establishments primarily engaged in dismantling automobiles and wholesaling used automotive parts and accessories. These establishments also typically sell dismantled automobiles to metal scrap dealers.',
  },
  {
    code: '4161',
    title: 'Electrical, plumbing, heating and air-conditioning equipment and supplies merchant wholesalers',
    description:
      'This industry group comprises establishments primarily engaged in wholesaling electrical construction supplies, and plumbing, heating and air-conditioning equipment and supplies.',
  },
  {
    code: '4162',
    title: 'Metal service centres',
    description:
      'This industry group comprises establishments primarily engaged in wholesaling metals and metal products. These establishments may also cut, bend or otherwise prepare metals to customer specification.',
  },
  {
    code: '4163',
    title: 'Lumber, millwork, hardware and other building supplies merchant wholesalers',
    description:
      'This industry group comprises establishments primarily engaged in wholesaling lumber and millwork, paint, glass, wallpaper, hardware and other building supplies.',
  },
  {
    code: '4171',
    title: 'Farm, lawn and garden machinery and equipment merchant wholesalers',
    description:
      'This industry group comprises establishments primarily engaged in wholesaling new or used farm, lawn and garden machinery, equipment and parts.',
  },
  {
    code: '4172',
    title: 'Construction, forestry, mining, and industrial machinery, equipment and supplies merchant wholesalers',
    description:
      'This industry group comprises establishments primarily engaged in wholesaling construction, forestry, mining and industrial machinery, equipment and supplies.',
  },
  {
    code: '4173',
    title: 'Computer and communications equipment and supplies merchant wholesalers',
    description:
      'This industry group comprises establishments primarily engaged in wholesaling new and used computers, computer peripherals and pre-packaged computer software.',
  },
  {
    code: '4179',
    title: 'Other machinery, equipment and supplies merchant wholesalers',
    description:
      'This industry group comprises establishments primarily engaged in wholesaling office, store, service industry, professional and other machinery, equipment and supplies.',
  },
  {
    code: '4181',
    title: 'Recyclable material merchant wholesalers',
    description:
      'This industry group comprises establishments primarily engaged in wholesaling recyclable metals, paper and paperboard, and other recyclable materials.',
  },
  {
    code: '4182',
    title: 'Paper, paper product and disposable plastic product merchant wholesalers',
    description:
      'This industry group comprises establishments primarily engaged in wholesaling newsprint, stationery and office supplies, other paper and paper products, and disposable plastic products.',
  },
  {
    code: '4183',
    title: 'Agricultural supplies merchant wholesalers',
    description:
      'This industry group comprises establishments primarily engaged in wholesaling agricultural feeds, seeds and processed seeds, agricultural chemicals and other farm supplies.',
  },
  {
    code: '4184',
    title: 'Chemical (except agricultural) and allied product merchant wholesalers',
    description:
      'This industry group comprises establishments primarily engaged in wholesaling industrial and household chemicals, cleaning compounds and preparations, plastics resins, plastic basic forms and shapes, and industrial gases.',
  },
  {
    code: '4185',
    title: 'Mineral, ore and precious metal merchant wholesalers',
    description:
      'This industry group comprises establishments primarily engaged in wholesaling minerals, ores and concentrates, precious metals and unfinished precious stones.',
  },
  {
    code: '4186',
    title: 'Log, wood chips, and other wood products merchant wholesalers',
    description:
      'This industry group comprises establishments primarily engaged in wholesaling logs and bolts, wood chips and other unprocessed forest products and other wood products.',
  },
  {
    code: '4189',
    title: 'Other miscellaneous merchant wholesalers',
    description:
      'This industry group comprises establishments, not classified to any other industry group, primarily engaged in wholesaling second-hand goods and other products.',
  },
  {
    code: '4191',
    title: 'Business-to-business electronic markets, and agents and brokers',
    description:
      "This industry group comprises establishments primarily engaged in buying and/or selling products, owned by others, and generally receiving a fee or a commission for the service. These establishments may be known as business-to-business electronic markets, commission merchants, import agents or brokers, export agents or brokers, manufacturers' agents, purchasing agents, selling agents, and they may deal in any type of product. These establishments bring together sellers and buyers or undertake commercial transactions on behalf of a principal, without taking title of the goods bought or sold.",
  },
  {
    code: '4411',
    title: 'Automobile dealers',
    description:
      'This industry group comprises establishments primarily engaged in retailing new and used automobiles, sport utility vehicles, and light-duty trucks and vans, including mini-vans.',
  },
  {
    code: '4412',
    title: 'Other motor vehicle dealers',
    description:
      'This industry group comprises establishments primarily engaged in retailing new and used vehicles, except automobiles, sport utility vehicles, and light-duty trucks and vans, including mini-vans. Establishments engaged in the retailing of motor homes, recreational trailers, campers, motorcycles, recreational watercraft, snowmobiles, off-road all-terrain vehicles, utility trailers and aircraft are included.',
  },
  {
    code: '4413',
    title: 'Automotive parts, accessories and tire retailers',
    description:
      'This industry group comprises establishments primarily engaged in retailing automotive parts and accessories.',
  },

  {
    code: '4421',
    title: 'Furniture stores',
    description:
      'This industry group comprises establishments primarily engaged in retailing new household and office furniture. These establishments may also retail major appliances, home electronics, home furnishings and floor coverings, and may provide interior decorating services.',
    isExpired: true,
  },
  {
    code: '4422',
    title: 'Home furnishings stores',
    description:
      'This industry group comprises establishments primarily engaged in retailing home furnishings, such as floor coverings, window treatments, kitchen and tableware, bedding and linens, lamps and shades, bathroom accessories, and print and picture frames.',
    isExpired: true,
  },
  {
    code: '4431',
    title: 'Electronics and appliance stores',
    description:
      'This industry group comprises establishments primarily engaged in retailing household appliances, home audio and video equipment, audio and video recordings, cameras, computers, and related goods. These establishments may also retail replacement parts and provide repair services.',
    isExpired: true,
  },

  {
    code: '4441',
    title: 'Building material and supplies dealers',
    description:
      'This industry group comprises establishments primarily engaged in retailing building materials, hardware, paint, wallpaper and related supplies.',
  },
  {
    code: '4442',
    title: 'Lawn and garden equipment and supplies retailers',
    description:
      'This industry group comprises establishments primarily engaged in retailing lawn and garden equipment and supplies.',
  },
  {
    code: '4451',
    title: 'Grocery and convenience retailers',
    description:
      'This industry group comprises establishments primarily engaged in retailing a general line of food products.',
  },
  {
    code: '4452',
    title: 'Specialty food retailers',
    description:
      'This industry group comprises establishments primarily engaged in retailing specialized lines of food products.',
  },
  {
    code: '4453',
    title: 'Beer, wine and liquor retailers',
    description:
      'This industry group comprises establishments primarily engaged in retailing packaged alcoholic beverages, such as beer, wine and liquor.',
  },
  {
    code: '4461',
    title: 'Health and personal care stores',
    description:
      'This industry group comprises establishments primarily engaged in retailing health and personal care products. Drug stores and pharmacies, cosmetics, beauty supplies and perfume stores, optical goods stores, food (health) supplement stores and health appliance stores are included.',
    isExpired: true,
  },
  {
    code: '4471',
    title: 'Gasoline stations',
    description:
      'This industry group comprises establishments primarily engaged in retailing motor fuels, whether or not the gasoline station is operated in conjunction with a convenience store, repair garage, restaurant or other type of operation. Establishments that operate gasoline stations on behalf of their owners and receive a commission on the sale of fuels are also included.',
    isExpired: true,
  },
  {
    code: '4481',
    title: 'Clothing stores',
    description:
      'This industry group comprises establishments primarily engaged in retailing new, ready-to-wear clothing.',
    isExpired: true,
  },
  {
    code: '4482',
    title: 'Shoe stores',
    description:
      'This industry group comprises establishments primarily engaged in retailing all types of new footwear. These establishments may also retail shoe-care products.',
    isExpired: true,
  },
  {
    code: '4483',
    title: 'Jewellery, luggage and leather goods stores',
    description:
      'This industry group comprises establishments primarily engaged in retailing jewellery, luggage and leather goods, and clothing accessories, such as hats, gloves, handbags, ties and belts.',
    isExpired: true,
  },
  {
    code: '4491',
    title: 'Furniture, floor covering, window treatment and other home furnishings retailers',
    description:
      'This industry group comprises establishments primarily engaged in retailing new household and office furniture, floor coverings, window treatment and other home furnishings, kitchen and tableware, bedding and linens, lamps and shades, bathroom accessories, and print and picture frames. These establishment may also provide interior decorating services.',
  },
  {
    code: '4492',
    title: 'Electronics and appliances retailers',
    description:
      'This industry group comprises establishments primarily engaged in retailing household appliances, home audio and video equipment, audio and video recordings, cameras, computers, and related goods. These establishments may also retail replacement parts and provide repair services.',
  },
  {
    code: '4511',
    title: 'Sporting goods, hobby and musical instrument stores',
    description:
      'This industry group comprises establishments primarily engaged in retailing new sporting goods, games and toys, and musical instruments.',
    isExpired: true,
  },
  {
    code: '4513',
    title: 'Book stores and news dealers',
    description:
      'This industry group comprises establishments primarily engaged in retailing new books, newspapers, magazines and other peiodicals.',
    isExpired: true,
  },
  {
    code: '4521',
    title: 'Department stores',
    description:
      'This industry group comprises establishments primarily engaged in retailing a wide range of products, with each merchandise line constituting a separate department within the store. Selected departments may be operated by separate establishments, on a concession basis.',
    isExpired: true,
  },
  {
    code: '4529',
    title: 'Other general merchandise stores',
    description:
      'This industry group comprises establishments, not classified to any other industry group, primarily engaged in retailing goods in general merchandise stores.',
    isExpired: true,
  },
  {
    code: '4531',
    title: 'Florists',
    description:
      'This industry group comprises establishments primarily engaged in retailing cut flowers, floral arrangements, and potted plants grown elsewhere. These establishments typically prepare the arrangements they sell.',
    isExpired: true,
  },
  {
    code: '4532',
    title: 'Office supplies, stationery and gift stores',
    description:
      'This industry group comprises establishments primarily engaged in retailing new office supplies, stationery and gifts.',
    isExpired: true,
  },
  {
    code: '4533',
    title: 'Used merchandise stores',
    description:
      'This industry group comprises establishments primarily engaged in retailing used merchandise. Establishments primarily engaged in retailing antiques are also included.',
    isExpired: true,
  },
  {
    code: '4539',
    title: 'Other miscellaneous store retailers',
    description:
      'This industry group comprises establishments, not classified to any other industry group, primarily engaged in retailing new merchandise in other types of specialty stores.',
    isExpired: true,
  },
  {
    code: '4541',
    title: 'Electronic shopping and mail-order houses',
    description:
      'This industry group comprises establishments primarily engaged in retailing all types of merchandise using the electronic and print media to induce direct response by the customer. These establishments can employ methods, such as broadcasting infomercials, broadcasting and publishing direct-response advertising and publishing traditional or electronic catalogues, to display their merchandise and reach their customers. They can also provide websites facilitating consumer-to-consumer or business-to-consumer trade in new and used goods, on an auction basis, using the Internet. Transactions between these retailers and their customers typically require the use of information technology (telephone or computer network) and the delivery of merchandise is typically done by mail or courier. Establishments primarily engaged in retailing from catalogue showrooms, without stock, are included.',
    isExpired: true,
  },
  {
    code: '4542',
    title: 'Vending machine operators',
    description:
      'This industry group comprises establishments primarily engaged in owning, stocking and servicing vending machines designed to retail merchandise.',
    isExpired: true,
  },
  {
    code: '4543',
    title: 'Direct selling establishments',
    description:
      'This industry group comprises establishments primarily engaged in non-store retailing, except direct-response advertising and operating vending machines. These establishments use methods, such as home delivery, door-to-door solicitation, in-home demonstration and displaying of merchandise through temporary stalls or kiosks, to reach their customers and market their merchandise. Direct sales establishments may operate from an office and have incidental sales of items.',
    isExpired: true,
  },
  {
    code: '4551',
    title: 'Department stores',
    description:
      'This industry group comprises establishments primarily engaged in retailing a wide range of products, with each merchandise line constituting a separate department within the store. Selected departments may be operated by separate establishments, on a concession basis.',
  },
  {
    code: '4552',
    title: 'Warehouse clubs, Supercentres and other general merchandise retailers',
    description:
      'This industry group comprises establishments primarily engaged in retailing a general line of grocery items typically by multi-unit cases and/or in large formats, in combination with a general line of non-grocery items; and typically charging a membership fee. It also comprises of establishments, not classified to any other industry group, primarily engaged in retailing goods in general merchandise retailers.',
  },
  {
    code: '4561',
    title: 'Health and personal care retailers',
    description:
      'This industry group comprises establishments primarily engaged in retailing health and personal care products. Drug stores and pharmacies, cosmetics, beauty supplies and perfume retailers, optical goods retailers, food (health) supplement retailers and health appliance retailers are included.',
  },
  {
    code: '4571',
    title: 'Gasoline stations',
    description:
      'This industry group comprises establishments primarily engaged in retailing motor fuels, whether or not the gasoline station is operated in conjunction with a convenience store, repair garage, restaurant or other type of operation. Establishments that operate gasoline stations on behalf of their owners and receive a commission on the sale of fuels are also included.',
  },
  {
    code: '4572',
    title: 'Fuel dealers',
    description:
      'This industry group comprises establishments primarily engaged in in retailing heating oil, liquefied petroleum gas (LPG) and other fuels via direct selling.',
  },
  {
    code: '4581',
    title: 'Clothing and clothing accessories retailers',
    description:
      'This industry group comprises establishments primarily engaged in retailing new, ready-to-wear clothing and clothing accessories.',
  },
  {
    code: '4582',
    title: 'Shoe retailers',
    description:
      'This industry group comprises establishments primarily engaged in retailing all types of new footwear. These establishments may also retail shoe-care products.',
  },
  {
    code: '4583',
    title: 'Jewellery, luggage and leather goods retailers',
    description:
      'This industry group comprises establishments primarily engaged in retailing jewellery, luggage and leather goods, and various leather items such as hats, gloves, handbags, ties and belts.',
  },
  {
    code: '4591',
    title: 'Sporting goods, hobby and musical instrument retailers',
    description:
      'This industry group comprises establishments primarily engaged in retailing new sporting goods, games and toys, and musical instruments.',
  },
  {
    code: '4592',
    title: 'Book retailers and news dealers',
    description:
      'This industry group comprises establishments primarily engaged in retailing new books, newspapers, magazines and other periodicals.',
  },
  {
    code: '4593',
    title: 'Florists',
    description:
      'This industry group comprises establishments primarily engaged in retailing cut flowers, floral arrangements, and potted plants grown elsewhere. These establishments typically prepare the arrangements they sell.',
  },
  {
    code: '4594',
    title: 'Office supplies, stationery and gift retailers',
    description:
      'This industry group comprises establishments primarily engaged in retailing new office supplies, stationery and gifts.',
  },
  {
    code: '4595',
    title: 'Used merchandise retailers',
    description:
      'This industry group comprises establishments primarily engaged in retailing used merchandise. Establishments primarily engaged in retailing antiques are also included.',
  },
  {
    code: '4599',
    title: 'Other miscellaneous store retailers',
    description:
      'This industry group comprises establishments, not classified to any other industry group, primarily engaged in retailing new merchandise in other types of specialty retailers.',
  },
  {
    code: '4811',
    title: 'Scheduled air transportation',
    description:
      'This industry group comprises establishments primarily engaged in transporting passengers and/or goods by aircraft, over regular routes and on regular schedules. Establishments in this industry have less flexibility with respect to choice of airports, hours of operation, load factors and similar operational characteristics than do establishments in 4812, Non-scheduled air transportation.',
  },
  {
    code: '4812',
    title: 'Non-scheduled air transportation',
    description:
      'This industry group comprises establishments primarily engaged in the non-scheduled air transportation of passengers and/or goods. Establishments in this industry have more flexibility with respect to choice of airports, hours of operation, load factors and similar operational characteristics than do establishments in 4811, Scheduled air transportation. Establishments primarily engaged in providing specialty air transportation or flying services using small, general-purpose aircraft are included.',
  },
  {
    code: '4821',
    title: 'Rail transportation',
    description:
      'This industry group comprises establishments primarily engaged in operating railways. Establishments primarily engaged in the operation of long-haul or mainline railways, short-haul railways and passenger railways are included.',
  },
  {
    code: '4831',
    title: 'Deep sea, coastal and Great Lakes water transportation',
    description:
      'This industry group comprises establishments primarily engaged in deep sea, coastal and Great Lakes water transportation of freight and passengers. The St. Lawrence Seaway is considered to be part of the Great Lakes system. Establishments that operate ocean-going cruise ships are included.',
  },
  {
    code: '4832',
    title: 'Inland water transportation',
    description:
      'This industry group comprises establishments primarily engaged in the inland water transportation of freight and passengers. Transportation within harbours is included.',
  },
  {
    code: '4841',
    title: 'General freight trucking',
    description:
      'This industry group comprises establishments primarily engaged in the local or long distance trucking of general freight. General freight trucking does not require the use of specialized equipment. The trucks used can handle a wide variety of commodities. Freight is generally palletized, and generally carried in a box, container or van trailer.',
  },
  {
    code: '4842',
    title: 'Specialized freight trucking',
    description:
      'This industry group comprises establishments primarily engaged in specialized freight trucking. These establishments transport articles that, because of size, weight, shape or other inherent characteristics, require specialized equipment for transportation. Some important types of specialized equipment are bulk tankers, dump trucks and trailers, refrigerated vans, and motor vehicle haulers. Establishments that transport used household and office goods are included.',
  },
  {
    code: '4851',
    title: 'Urban transit systems',
    description:
      'This industry group comprises establishments primarily engaged in operating local and suburban mass passenger transit systems. Such transportation may involve the use of one or more modes of transport including light rail, subways and streetcars, as well as buses. These establishments operate over fixed routes and schedules, and allow passengers to pay on a per-trip basis (whether or not they also accept payment methods such as monthly passes).',
  },
  {
    code: '4852',
    title: 'Interurban and rural bus transportation',
    description:
      'This industry group comprises establishments primarily engaged in providing passenger transportation, principally outside a single municipality and its suburban areas, primarily by bus. These establishments operate over fixed routes and schedules, and charge a per-trip fee.',
  },
  {
    code: '4853',
    title: 'Taxi and limousine service',
    description:
      'This industry group comprises establishments primarily engaged in providing passenger transportation by taxi and limousine.',
  },
  {
    code: '4854',
    title: 'School and employee bus transportation',
    description:
      'This industry group comprises establishments primarily engaged in operating buses and other motor vehicles to transport pupils to and from school or employees to and from work. These establishments operate over fixed routes and schedules, but do not charge a per-trip fee.',
  },
  {
    code: '4855',
    title: 'Charter bus industry',
    description:
      'This industry group comprises establishments primarily engaged in providing charter bus services. These establishments do not operate over fixed routes and schedules, and rent the entire vehicle, rather than individual seats.',
  },
  {
    code: '4859',
    title: 'Other transit and ground passenger transportation',
    description:
      'This industry group comprises establishments, not classified to any other industry group, primarily engaged in providing shuttle services to airports and similar facilities, special needs transportation services and other transit and ground passenger transport. Shuttle services included in this industry group are those that use vans and/or buses as a means of transport. They usually travel on fixed routes and service particular hotels or carriers. Special needs transportation establishments use conventional or specially converted vehicles to provide passenger transportation to the infirm, elderly or persons with a disability.',
  },
  {
    code: '4861',
    title: 'Pipeline transportation of crude oil',
    description:
      'This industry group comprises establishments primarily engaged in the pipeline transportation of crude oil.',
  },
  {
    code: '4862',
    title: 'Pipeline transportation of natural gas',
    description:
      'This industry group comprises establishments primarily engaged in the pipeline transportation of natural gas, from gas fields or processing plants to local distribution systems.',
  },
  {
    code: '4869',
    title: 'Other pipeline transportation',
    description:
      'This industry group comprises establishments, not classified to any other industry group, primarily engaged in pipeline transportation.',
  },
  {
    code: '4871',
    title: 'Scenic and sightseeing transportation, land',
    description:
      'This industry group comprises establishments primarily engaged in providing scenic and sightseeing transportation on land, such as steam train excursions and horse-drawn sightseeing rides.',
  },
  {
    code: '4872',
    title: 'Scenic and sightseeing transportation, water',
    description:
      'This industry group comprises establishments primarily engaged in providing scenic and sightseeing transportation on water, such as sightseeing, dinner cruises or air-boat rides. These establishments often use vintage or specialized transportation equipment. The services provided are local in nature, usually involving same-day return. Establishments that provide charter fishing services are included.',
  },
  {
    code: '4879',
    title: 'Scenic and sightseeing transportation, other',
    description:
      'This industry group comprises establishments, not classified to any other industry, primarily engaged in providing scenic and sightseeing transportation. Some examples of these services are scenic helicopter rides and hot-air balloon rides.',
  },
  {
    code: '4881',
    title: 'Support activities for air transportation',
    description:
      'This industry group comprises establishments primarily engaged in providing specialized services to the air transport industry.',
  },
  {
    code: '4882',
    title: 'Support activities for rail transportation',
    description:
      'This industry group comprises establishments primarily engaged in providing specialized services to the rail transport industry. Establishments engaged in the operation of railway terminals and stations, and the maintenance of railway rights-of-way and structures are included.',
  },
  {
    code: '4883',
    title: 'Support activities for water transportation',
    description:
      'This industry group comprises establishments primarily engaged in providing specialized services to the water transportation industry.',
  },
  {
    code: '4884',
    title: 'Support activities for road transportation',
    description:
      'This industry group comprises establishments primarily engaged in providing specialized services to trucking establishments, bus operators and other establishments using the road network.',
  },
  {
    code: '4885',
    title: 'Freight transportation arrangement',
    description:
      'This industry group comprises establishments primarily engaged in acting as intermediaries between shippers and carriers. These establishments are usually referred to as freight forwarders, marine shipping agents or customs brokers. They may offer a combination of services which may span transportation modes.',
  },
  {
    code: '4889',
    title: 'Other support activities for transportation',
    description:
      'This industry group comprises establishments, not classified to any other industry, primarily engaged in providing specialized services to transportation establishments. Establishments engaged in packing, crating and otherwise preparing goods for transportation are included.',
  },
  {
    code: '4911',
    title: 'Postal service',
    description:
      'This industry group comprises establishments primarily engaged in operating the postal service. Establishments of the Post Office, other than those primarily engaged in providing courier services, are classified in this industry, as well as establishments that carry on one or more functions of the postal service on a contract basis, except the delivery of mail in bulk.',
  },
  {
    code: '4921',
    title: 'Couriers',
    description:
      'This industry group comprises establishments primarily engaged in providing air, surface or combined courier delivery services. Courier establishments of the Post Office are included.',
  },
  {
    code: '4922',
    title: 'Local messengers and local delivery',
    description:
      'This industry group comprises establishments primarily engaged in providing messenger and delivery services of small parcels within a single urban area. Establishments engaged in the delivery of letters and documents, such as legal documents, often by bicycle or on foot; and the delivery of small parcels, such as take-out restaurant meals, alcoholic beverages and groceries, on a fee basis, usually by small truck or van, are included.',
  },
  {
    code: '4931',
    title: 'Warehousing and storage',
    description:
      "This industry group comprises establishments primarily engaged in operating general merchandise, refrigerated and other warehousing and storage facilities. Included in this industry group are third-party warehouses serving retail chains and wholesalers. Establishments in this industry group provide facilities to store goods for customers. They do not take title to the goods they handle. These establishments take responsibility for storing the goods and keeping them secure. They may also provide a range of services, often referred to as logistics services, related to the distribution of a customer's goods. Logistics services can include labelling, breaking bulk, inventory control and management, light assembly, order entry and fulfillment, packaging, pick and pack, price marking and ticketing and transportation arrangement. However, establishments in this industry group always provide storage services in addition to any logistics services. Furthermore, the storage of goods must be more than incidental to the performance of a service such as price marking. Both public and contract warehousing are included in this industry group. Public warehousing generally provides short-term storage, typically for less than thirty days. Contract warehousing generally involves a longer-term contract, often including the provision of logistical services and dedicated facilities. Bonded warehousing and storage services, and warehouses located in free trade zones, are included in the industries of this industry group. However, storage services primarily associated with the provision of credit are not.",
  },
  {
    code: '5111',
    title: 'Newspaper, periodical, book and directory publishers',
    description:
      'This industry group comprises establishments primarily engaged in publishing (or publishing and printing) newspapers, periodicals, books, maps, directories, databases and other works, such as calendars, catalogues and greeting cards.',
    isExpired: true,
  },
  {
    code: '5112',
    title: 'Software publishers',
    description:
      'This industry group comprises establishments primarily engaged in publishing computer software, usually for multiple clients and generally referred to as packaged software. These establishments carry out operations necessary for producing and distributing computer software, such as designing, providing documentation, assisting in installation and providing support services to software purchasers. They may design and publish, or publish only.',
    isExpired: true,
  },
  {
    code: '5121',
    title: 'Motion picture and video industries',
    description:
      'This industry group comprises establishments primarily engaged in producing and/or distributing motion pictures, videos, television programs or commercials; exhibiting motion pictures or providing post-production and related services.',
  },
  {
    code: '5122',
    title: 'Sound recording industries',
    description:
      'This industry group comprises establishments primarily engaged in producing and distributing music recordings, publishing music, or providing sound recording and related services.',
  },
  {
    code: '5131',
    title: 'Newspaper, periodical, book and directory publishers',
    description:
      'This industry group comprises establishments primarily engaged in publishing (or publishing and printing) newspapers, periodicals, books, maps, directories, databases and other works, such as calendars, catalogues and greeting cards.',
  },
  {
    code: '5132',
    title: 'Software publishers',
    description:
      'This industry group comprises establishments primarily engaged in publishing computer software, usually for multiple clients and generally referred to as packaged software. These establishments carry out operations necessary for producing and distributing computer software, such as designing, providing documentation, assisting in installation and providing support services to software purchasers. They may design and publish, or publish only.',
  },
  {
    code: '5151',
    title: 'Radio and television broadcasting',
    description:
      'This industry group comprises establishments primarily engaged in operating broadcasting studios and facilities for the transmission of a variety of radio and television broadcasts, including entertainment, news, talk shows and other programs. These establishments produce, purchase and schedule programs; and generate revenues from the sale of air time to advertisers, from donations and subsidies, or from the sale of programs.',
    isExpired: true,
  },
  {
    code: '5152',
    title: 'Pay and specialty television',
    description:
      'This industry group comprises establishments primarily engaged in broadcasting television programs, in a defined and limited format, such as family and youth-oriented, news, feature films, music, health, sports, religion, weather, travel and educational programming. These establishments may produce programs in their own broadcasting studios or they may acquire programming from external sources. The programming is delivered to subscribers by operators of cable or satellite distribution systems.',
    isExpired: true,
  },
  {
    code: '5161',
    title: 'Radio and television broadcasting stations',
    description:
      'This industry group comprises establishments operating radio or television broadcasting stations for the programming and transmission to the public. Programming may originate in their own studio, from an affiliated network, or from external sources.',
  },
  {
    code: '5162',
    title: 'Media streaming distribution services and other media networks and content providers',
    description:
      'This industry group comprises establishments primarily providing media streaming distribution services, operating media broadcasting, satellite and cable television networks, and supplying information, such as news reports, articles, pictures, and features, to the news media. These may operate by cable systems, satellite transmission or over the Internet. These establishments distribute textual, audio, and/or video content of general or specific interest.',
  },
  {
    code: '5173',
    title: 'Wired and wireless telecommunications carriers(except satellite)',
    description:
      'This industry group comprises establishments primarily engaged in providing telecommunications and video entertainment services to their customer premises and/or to mobile telecommunication devices over network facilities operated by them. These establishments can own a network, lease a network or combine leased and owned facilities and their networks can integrate various technologies.',
  },
  {
    code: '5174',
    title: 'Satellite telecommunications',
    description:
      'This industry group comprises establishments primarily engaged in providing mobile and fixed telecommunications services over satellite network facilities operated by them or by distributing the services of other satellite network operators. These establishments typically serve a business clientele (telecommunication carriers, private business networks, broadcasters) but can also provide services to individual customers that are beyond the reach of terrestrial networks (e.g., high speed Internet).',
  },
  {
    code: '5179',
    title: 'Other telecommunications',
    description:
      'This industry group comprises establishments primarily engaged in providing telecommunications and/or video entertainment services over network facilities operated by others and establishments primarily engaged in operating telecommunications networks or providing telecommunication services not elsewhere classified.',
  },
  {
    code: '5182',
    title: 'Computing infrastructure providers, data processing, web hosting, and related services',
    description:
      'This industry group comprises establishments primarily engaged in providing the infrastructure for data processing, hosting, and related services.',
  },
  {
    code: '5191',
    title: 'Other information services',
    description:
      'This industry group comprises establishments, not classified to any other industry, primarily engaged in providing other information services. The main components are news syndicates, libraries and archives, Internet publishing and broadcasting, and web search portals.',
    isExpired: true,
  },
  {
    code: '5192',
    title: 'Web search portals, libraries and archives, and all other information services',
    description:
      'This industry group comprises establishments, not classified to any other industry, primarily engaged in providing other information services. The main components are libraries and archives, web search portals and all other information services.',
  },
  {
    code: '5211',
    title: 'Monetary authorities - central bank',
    description:
      "This industry group comprises establishments primarily engaged in performing central banking functions, such as issuing currency (paper money); managing the nation's money supply and international reserves; overseeing payment, clearing and settlement systems; holding deposits that represent the reserves of other banks and institutions; and acting as fiscal agent for the federal government. The institutional arrangements for performing these functions and for conducting monetary policy may differ among the countries. In Canada, these functions are performed by the Bank of Canada, in Mexico by the Bank of Mexico, and in the United States by the Federal Reserve Banks and their branches.",
  },
  {
    code: '5221',
    title: 'Depository credit intermediation',
    description:
      'This industry group comprises establishments primarily engaged in accepting deposits and lending funds. Deposits are the principal source of funds loaned.',
  },
  {
    code: '5222',
    title: 'Non-depository credit intermediation',
    description:
      'This industry group comprises establishments, both public (government-sponsored enterprises) and private, primarily engaged in extending credit or lending funds raised by credit market borrowing, such as by issuing commercial paper and other debt instruments, and by borrowing from other financial intermediaries.',
  },
  {
    code: '5223',
    title: 'Activities related to credit intermediation',
    description:
      'This industry group comprises establishments primarily engaged in providing services closely related to credit intermediation, but not acting as intermediaries.',
  },
  {
    code: '5231',
    title: 'Securities and commodity contracts intermediation and brokerage',
    description:
      'This industry group comprises establishments primarily engaged in putting capital at risk in the process of underwriting securities issues or in making markets for securities, and acting as intermediaries between buyers and sellers of securities.',
  },
  {
    code: '5232',
    title: 'Securities and commodity exchanges',
    description:
      'This industry group comprises establishments primarily engaged in providing marketplaces and mechanisms for the purpose of facilitating the buying and selling of stocks, stock options, bonds or commodity contracts. The establishments in this industry do not buy, sell, own or set the prices of the traded securities and/or commodities.',
  },
  {
    code: '5239',
    title: 'Other financial investment activities',
    description:
      'This industry group comprises establishments, not classified to any other industry group, primarily engaged in managing portfolios of securities and providing investment advice, trust, fiduciary, custody and other investment services.',
  },
  {
    code: '5241',
    title: 'Insurance carriers',
    description:
      'This industry group comprises establishments primarily engaged in underwriting annuities, insurance policies and reinsurance. The establishments of this group invest premiums to build up a portfolio of financial assets to be used against future claims. Contributions and premiums are set on the basis of actuarial calculations of reserves. Direct insurance carriers that are primarily engaged in underwriting annuities and insurance policies directly to policy holders, and reinsurance carriers that are primarily engaged in assuming all or part of the risk associated with existing insurance policies originally underwritten by other insurance carriers, are included. Industries are defined in terms of the type of risk against which the policy holders are being insured, such as death, loss of employment due to age or disability, and property damage.',
  },
  {
    code: '5242',
    title: 'Agencies, brokerages and other insurance related activities',
    description:
      'This industry group comprises establishments primarily engaged in selling insurance or providing services related to insurance.',
  },
  {
    code: '5261',
    title: 'Pension funds',
    description:
      'This industry group comprises funds containing net assets set aside for the purpose of meeting retirement benefit payments of the pension plan, when they become due. Pension funds may or may not have separate legal identities and may or may not have trustees. A pension plan is a reporting entity separate from a sponsor and the plan participants that, by any arrangement (contractual or otherwise), establishes a program to provide retirement income to employees. This class includes pension plans of all types, regardless of whether the fund is registered as a separate legal identity or is administered by trustees.',
  },
  {
    code: '5269',
    title: 'Other funds and financial vehicles',
    description:
      'This industry group comprises portfolios of specialized or diversified securities and other investments held on behalf of unit holders, shareholders or investors.',
  },
  {
    code: '5311',
    title: 'Lessors of real estate',
    description:
      'This industry group comprises establishments primarily engaged in renting and leasing real estate properties. These establishments may operate (rent, lease, administer and maintain) their properties on own account, or they may subcontract the operation to a third party. This industry group also includes establishments that lease real estate from others, and sublease it to others.',
  },
  {
    code: '5312',
    title: 'Offices of real estate agents and brokers',
    description:
      'This industry group comprises establishments primarily engaged in renting, buying and selling real estate for others, on a fee or commission basis. These establishments assist vendors by advertising and listing properties and conducting open houses for prospective buyers, assist prospective buyers by selecting, visiting and making purchase offers. They may also rent or lease properties on behalf of clients.',
  },
  {
    code: '5313',
    title: 'Activities related to real estate',
    description:
      'This industry group comprises establishments primarily engaged in activities related to real estate, such as real estate property management, real estate appraising and real estate listing.',
  },
  {
    code: '5321',
    title: 'Automotive equipment rental and leasing',
    description:
      'This industry group comprises establishments primarily engaged in renting or leasing vehicles, such as passenger cars, passenger vans, trucks, truck tractors, buses, semi-trailers, utility trailers and recreational vehicles (RVs), without drivers. These establishments generally operate from a retail-like facility; some offer only short-term rental, others only longer-term leases, and some provide both type of services.',
  },
  {
    code: '5322',
    title: 'Consumer goods rental',
    description:
      'This industry group comprises establishments primarily engaged in renting or leasing personal and household goods. These establishments generally provide short-term rental, although, in some instances, the goods may be leased for longer periods of time. These establishments often operate from a retail-like or store-front facility.',
  },
  {
    code: '5323',
    title: 'General rental centres',
    description:
      "This industry group comprises establishments primarily engaged in renting a range of consumer, commercial and industrial equipment. These establishments typically operate from conveniently located facilities in which they maintain inventories of goods and equipment that are rented for short periods of time. The type of equipment that these establishments provide often includes, but is not limited to, contractors' and builders' tools and equipment, home repair tools, lawn and garden equipment, moving equipment and supplies, and party and banquet equipment and supplies.",
  },
  {
    code: '5324',
    title: 'Commercial and industrial machinery and equipment rental and leasing',
    description:
      'This industry group comprises establishments primarily engaged in renting or leasing commercial and industrial machinery and equipment, without operator. The types of establishments included in this industry group are generally involved in providing capital/investment-type equipment that clients use in their business operations. These establishments typically serve businesses and do not generally operate a retail-like or store-front facility.',
  },
  {
    code: '5331',
    title: 'Lessors of non-financial intangible assets (except copyrighted works)',
    description:
      'This industry group comprises establishments primarily engaged in holding non-financial intangible assets such as patents, trademarks, brand names, and/or franchise agreements, and allowing others to use or reproduce those assets for a fee.',
  },
  {
    code: '5411',
    title: 'Legal services',
    description:
      'This industry group comprises establishments primarily engaged in providing legal and paralegal services. Examples of establishments in this industry group are offices of lawyers, offices of notaries and offices of paralegals.',
  },
  {
    code: '5412',
    title: 'Accounting, tax preparation, bookkeeping and payroll services',
    description:
      'This industry group comprises establishments primarily engaged in auditing accounting records; designing accounting systems; preparing financial statements; developing budgets; preparing tax returns; processing payrolls; bookkeeping; and billing.',
  },
  {
    code: '5413',
    title: 'Architectural, engineering and related services',
    description:
      'This industry group comprises establishments primarily engaged in providing architectural, engineering and related services, such as structure design, drafting, building inspection, landscape design, surveying and mapping, laboratory and on-site testing, and interior, industrial, graphic and other specialized design services.',
  },
  {
    code: '5414',
    title: 'Specialized design services',
    description:
      'This industry group comprises establishments primarily engaged in providing specialized design services, except architectural, engineering and computer systems design.',
  },
  {
    code: '5415',
    title: 'Computer systems design and related services',
    description:
      "This industry group comprises establishments primarily engaged in providing expertise in the field of information technologies through one or more activities, such as writing, modifying, testing and supporting software to meet the needs of a particular customer, including custom video design and development and Internet webpage development; planning and designing computer systems that integrate hardware, software and communication technologies; on-site management and operation of clients' computer and data processing facilities; providing advice in the field of information technologies; and other professional and technical computer-related services, such as training and support after sales.",
  },
  {
    code: '5416',
    title: 'Management, scientific and technical consulting services',
    description:
      'This industry group comprises establishments primarily engaged in providing expert advice and assistance to other organizations on management, environmental, scientific and technical issues.',
  },
  {
    code: '5417',
    title: 'Scientific research and development services',
    description:
      'This industry group comprises establishments primarily engaged in conducting original investigation, undertaken on a systematic basis to gain new knowledge (research), and in the application of research findings or other scientific knowledge for the creation of new or significantly improved products or processes (experimental development). The industries within this industry group are defined on the basis of the domain of research; that is, on the scientific expertise of the establishment.',
  },
  {
    code: '5418',
    title: 'Advertising, public relations, and related services',
    description:
      'This industry group comprises establishments primarily engaged in creating mass-media advertising or public relation campaigns; placing advertising in media for advertisers or advertising agencies; selling media time or space to advertisers or advertising agencies for media owners; creating and implementing indoor or outdoor display advertising campaigns; creating and implementing direct mail advertising campaigns; delivering (except by mail) advertising materials or samples; creating and implementing specialty advertising campaigns; providing related services, such as sign painting and lettering, welcoming services and window trimming services.',
  },
  {
    code: '5419',
    title: 'Other professional, scientific and technical services',
    description:
      'This industry group comprises establishments, not classified to any other industry group, primarily engaged in providing professional, scientific and technical services. Examples of establishments included in this industry group are marketing research and public opinion polling houses; photographic studios; translators and interpreters; and veterinary practices.',
  },
  {
    code: '5511',
    title: 'Management of companies and enterprises',
    description:
      'This industry group comprises (1) legal entities engaged only in holding the securities of subsidiaries and affiliates for the purpose of owning a controlling interest or influencing the management decisions of these businesses, or (2), establishments primarily engaged in administering, overseeing, and managing other establishments of the company or enterprise and which may also hold the securities of their subsidiaries and affiliates. A characteristic of economic units in this sector is that all activities are focused on serving the economic units of the enterprise group, that is, they do not provide services to unaffiliated establishment.',
  },
  {
    code: '5611',
    title: 'Office administrative services',
    description:
      "This industry group comprises establishments primarily engaged in administering, directing or coordinating a range of day-to-day business operations, such as financing, billing and record keeping; personnel; physical distribution; and providing other administrative and managerial services. These establishments do not provide the operating staff to carry out the complete operations of a client's business.",
  },
  {
    code: '5612',
    title: 'Facilities support services',
    description:
      "This industry group comprises establishments primarily engaged in providing a combination of services to support operations within a client's facilities. These establishments typically provide a combination of services, such as janitorial; maintenance; trash disposal; guard and security; mail routing and other logistical support; reception; laundry; and related services, to support operations within facilities. They provide operating staff to carry out these support activities, but are not involved with, or responsible for, the core business or activities of the client.",
  },
  {
    code: '5613',
    title: 'Employment services',
    description:
      'This industry group comprises establishments primarily engaged in listing employment vacancies and selecting, referring and placing applicants in employment, either on a permanent or temporary basis; and establishments primarily engaged in supplying workers for limited periods of time to supplement the workforce of the client.',
  },
  {
    code: '5614',
    title: 'Business support services',
    description:
      'This industry group comprises establishments primarily engaged in providing business support services, such as preparing documents, operating telephone call centres, operating business service centres, collecting unpaid claims, and providing credit information.',
  },
  {
    code: '5615',
    title: 'Travel arrangement and reservation services',
    description:
      "This industry group comprises establishments primarily engaged in travel arrangement and reservation services. Examples of establishments in this industry group are tourist and travel agencies; travel tour operators and wholesale operators; convention and visitors' bureaus; airline, bus, railroad and steamship ticket offices; sports and theatrical ticket offices; and airline, hotel and restaurant reservation offices.",
  },
  {
    code: '5616',
    title: 'Investigation and security services',
    description:
      'This industry group comprises establishments primarily engaged in providing investigation and detective services, guard and patrol services, armoured car services and security system services.',
  },
  {
    code: '5617',
    title: 'Services to buildings and dwellings',
    description:
      'This industry group comprises establishments primarily engaged in exterminating and controlling insects, rodents and other pests; cleaning building interiors and windows; landscaping installation, care and maintenance; cleaning and dyeing rugs, carpets and upholstery; and providing other services to buildings and dwellings.',
  },
  {
    code: '5619',
    title: 'Other support services',
    description:
      'This industry group comprises establishments, not classified to any other industry group, primarily engaged in providing day-to-day support services.',
  },
  {
    code: '5621',
    title: 'Waste collection',
    description:
      'This industry group comprises establishments primarily engaged in collecting and hauling non-hazardous or hazardous waste within a local area. Establishments engaged in hazardous waste collection may be responsible for treating and packaging the waste for transport. Waste transfer stations are also included.',
  },
  {
    code: '5622',
    title: 'Waste treatment and disposal',
    description:
      'This industry group comprises establishments primarily engaged in operating land fill sites, incinerators, or other treatment or disposal facilities for non-hazardous or hazardous waste. Establishments that integrate the collection, treatment and disposal of waste are also included.',
  },
  {
    code: '5629',
    title: 'Remediation and other waste management services',
    description:
      'This industry group comprises establishments, not classified to any other industry group, primarily engaged in waste management activities, such as the remediation and clean-up of contaminated sites, the operation of material recovery facilities, and the cleaning of septic tanks.',
  },
  {
    code: '6111',
    title: 'Elementary and secondary schools',
    description:
      'This industry group comprises establishments primarily engaged in providing academic courses that comprise a basic preparatory education, that is, Kindergarten to Grade 12.',
  },
  {
    code: '6112',
    title: 'Community colleges and C.E.G.E.P.s',
    description:
      'This industry group comprises establishments primarily engaged in providing academic, or academic and technical courses and granting associate degrees, certificates or diplomas that are below the university level. The requirement for admission to an associate or equivalent degree program is at least a high school diploma or equivalent general academic training.',
  },
  {
    code: '6113',
    title: 'Universities',
    description:
      'This industry group comprises establishments primarily engaged in providing academic courses and granting degrees at the bachelor or graduate levels. The requirement for admission is at least a high school diploma or equivalent general academic training for baccalaureate programs, and often a baccalaureate degree for professional or graduate programs.',
  },
  {
    code: '6114',
    title: 'Business schools and computer and management training',
    description:
      'This industry group comprises establishments primarily engaged in providing courses in office procedures and secretarial and stenographic skills; conducting training in all phases of computer activities, including computer programming, software packages, computerized business systems, computer electronics technology, computer operations and local area network management; and offering an array of short-duration courses and seminars for management and professional development.',
  },
  {
    code: '6115',
    title: 'Technical and trade schools',
    description:
      'This industry group comprises establishments primarily engaged in providing vocational and technical training in a variety of technical subjects and trades. The training often leads to non-academic certification. Vocational correspondence schools are also included.',
  },
  {
    code: '6116',
    title: 'Other schools and instruction',
    description:
      'This industry group comprises establishments primarily engaged in providing instruction in fine arts; athletics and sports; languages; and other instruction (except academic, business, computer, management, and technical and trade instruction); and providing services, such as tutoring and exam preparation.',
  },
  {
    code: '6117',
    title: 'Educational support services',
    description:
      'This industry group comprises establishments primarily engaged in providing non-instructional services that support educational processes or systems.',
  },
  {
    code: '6211',
    title: 'Offices of physicians',
    description:
      'This industry group comprises establishments of licensed physicians primarily engaged in the private or group practice of general or specialized medicine or surgery. Offices of physicians, especially walk-in centres that accept patients without appointment and that often have extended office hours, are sometimes called clinics or medical centres. These establishments must not be confused with other out-patient centres that are also referred to as clinics.',
  },
  {
    code: '6212',
    title: 'Offices of dentists',
    description:
      'This industry group comprises establishments of licensed dentists primarily engaged in the private or group practice of general or specialized dentistry or dental surgery. Offices of dentists, especially walk-in centres that accept patients without appointment and that often have extended office hours, are sometimes called clinics or dental centres.',
  },
  {
    code: '6213',
    title: 'Offices of other health practitioners',
    description:
      'This industry group comprises establishments of health practitioners, other than physicians and dentists. Offices, especially walk-in centres that accept patients without appointment and that often have extended office hours, are sometimes called clinics or centres.',
  },
  {
    code: '6214',
    title: 'Out-patient care centres',
    description:
      'This industry group comprises establishments, with medical staff, primarily engaged in general out-patient care, by providing the services of a variety of health practitioners within the same establishment, and specialized out-patient services.',
  },
  {
    code: '6215',
    title: 'Medical and diagnostic laboratories',
    description:
      'This industry group comprises establishments primarily engaged in providing analytic or diagnostic services. These services are generally provided to the medical profession, or to the patient on referral from a health practitioner.',
  },
  {
    code: '6216',
    title: 'Home health care services',
    description:
      'This industry group comprises establishments primarily engaged in providing skilled nursing services in the home, combined with a range of other home services, such as personal care services, homemaker and companion services, physical therapy, medical social services, counselling, occupational and vocational therapy, dietary and nutritional services, speech therapy, audiology, medical equipment and supplies, medications and intravenous therapy. Only establishments that provide nursing services in combination with the other services listed are included.',
  },
  {
    code: '6219',
    title: 'Other ambulatory health care services',
    description:
      'This industry group comprises establishments, not classified to any other industry group, primarily engaged in providing ambulatory health care services, such as ambulance services, blood banks, blood donor stations, organ banks, blood pressure screening services, hearing testing services and physical examination services, except by health practitioners.',
  },
  {
    code: '6221',
    title: 'General medical and surgical hospitals',
    description:
      'This industry group comprises establishments, licensed as hospitals, primarily engaged in providing diagnostic and medical treatment to in-patients of any age with any of a wide variety of diseases or medical conditions. These establishments usually provide other services, such as out-patient services, diagnostic X-ray services, clinical laboratory services and pharmacy services.',
  },
  {
    code: '6222',
    title: 'Psychiatric and substance use hospitals',
    description:
      'This industry group comprises establishments, licensed as hospitals, primarily engaged in providing diagnostic and medical treatment, and monitoring patients with a mental illness or substance use condition. The treatment often requires an extended stay in the hospital. These hospitals may provide other services, such as out-patient services and electroencephalograph services.',
  },
  {
    code: '6223',
    title: 'Specialty hospitals (except psychiatric and substance use)',
    description:
      'This industry group comprises establishments, licensed as hospitals, primarily engaged in providing diagnostic and medical treatment to in-patients with a specific type of disease or medical condition, except psychiatric or substance use. Hospitals providing long-term care for the chronically ill and hospitals providing rehabilitation, restorative and adjustive services to physically-challenged or persons with a disability are included in this industry. Specialty hospitals may provide other services, such as out-patient services, diagnostic X-ray services, clinical laboratory services, physical therapy services, educational and vocational services, and psychological and social work services.',
  },
  {
    code: '6231',
    title: 'Nursing care facilities',
    description:
      'This industry group comprises establishments primarily engaged in providing in-patient nursing and rehabilitative services, and continuous personal care services. Individuals requiring nursing care usually require an extended stay in the care facility.',
  },
  {
    code: '6232',
    title:
      'Residential facilities for persons with an intellectual or developmental disability, a mental health or substance use condition',
    description:
      'This industry group comprises establishments primarily engaged in providing residential care to people with developmental disabilities, mental health conditions or substance use conditions.',
  },
  {
    code: '6233',
    title: 'Community care facilities for the elderly',
    description:
      'This industry group comprises establishments primarily engaged in providing residential and personal care services for the elderly and persons who are unable to fully care for themselves or who do not desire to live independently. The care typically includes room, board, supervision and assistance in daily living by providing services such as housekeeping. In some instances these establishments provide skilled nursing care for residents in separate on-site facilities.',
  },
  {
    code: '6239',
    title: 'Other residential care facilities',
    description:
      'This industry group comprises establishments, not classified to any other industry, primarily engaged in providing residential care, such as transition homes for women, homes for children with a mental health condition or disability, camps for delinquent youth, group foster homes, halfway group homes for delinquents and offenders, and orphanages.',
  },
  {
    code: '6241',
    title: 'Individual and family services',
    description:
      'This industry group comprises establishments primarily engaged in providing non-residential social assistance services for individual and families.',
  },
  {
    code: '6242',
    title: 'Community food and housing, and emergency and other relief services',
    description:
      'This industry group comprises establishments primarily engaged in the collection, preparation and delivery of food for the needy; providing short-term emergency shelter; and providing food, shelter, clothing, medical relief, resettlement and counselling to victims of domestic or international disasters or conflicts.',
  },
  {
    code: '6243',
    title: 'Vocational rehabilitation services',
    description:
      'This industry group comprises establishments primarily engaged in providing vocational rehabilitation or habilitation services, such as job counselling, job training, and work experience, to unemployed and underemployed persons, persons with disabilities, and persons who have a job-market disadvantage because of lack of education, job skill or experience; and training and employment to persons with a mental or physical disability in sheltered workshops.',
  },
  {
    code: '6244',
    title: 'Child day-care services',
    description:
      'This industry group comprises establishments primarily engaged in providing day-care services for infants or children. These establishments may care for older children when they are not in school and may also offer pre-kindergarten educational programs.',
  },
  {
    code: '7111',
    title: 'Performing arts companies',
    description:
      'This industry group comprises establishments primarily engaged in producing live presentations that involve the performances of actors and actresses, singers, dancers, musical groups and artists, and other performing artists. Examples of establishments in this industry group are theatre companies, dance companies, musical groups and artists, circuses and ice-skating shows.',
  },
  {
    code: '7112',
    title: 'Spectator sports',
    description:
      'This industry group comprises professional, semi-professional, or amateur sports clubs primarily engaged in presenting sporting events before an audience. These establishments may or may not operate the facility for presenting these events. Independent professional, semi-professional or amateur athletes (in their role as athletes), and operators of race tracks are also included.',
  },
  {
    code: '7113',
    title: 'Promoters (presenters) of performing arts, sports and similar events',
    description:
      'This industry group comprises establishments primarily engaged in organizing and promoting performing arts productions, sports events and similar events, such as festivals. Establishments in this industry group may operate arenas, stadiums, theatres or other related facilities, or they may present these events in facilities operated by others.',
  },
  {
    code: '7114',
    title: 'Agents and managers for artists, athletes, entertainers and other public figures',
    description:
      "This industry group comprises establishments primarily engaged in representing or managing creative and performing artists, sports figures, entertainers, and celebrities. These establishments represent their clients in contract negotiations, manage or organize the client's financial affairs, and generally promote the careers of their clients.",
  },
  {
    code: '7115',
    title: 'Independent artists, writers and performers',
    description:
      'This industry group comprises independent individuals (freelance) primarily engaged in performing in artistic productions, creating artistic and cultural works or productions, or providing technical expertise necessary for these productions. Independent celebrities, such as athletes, engaging in endorsement, speaking and similar services, are included.',
  },
  {
    code: '7121',
    title: 'Heritage institutions',
    description:
      'This industry group comprises establishments primarily engaged in preserving and exhibiting objects, sites and natural wonders of historical, cultural and educational value.',
  },
  {
    code: '7131',
    title: 'Amusement parks and arcades',
    description:
      'This industry group comprises establishments primarily engaged in operating amusement parks, amusement arcades and parlours.',
  },
  {
    code: '7132',
    title: 'Gambling industries',
    description:
      'This industry group comprises establishments primarily engaged in operating gambling facilities, such as casinos, bingo halls and video gaming terminals; or providing gambling services, such as lotteries and off-track betting.',
  },
  {
    code: '7139',
    title: 'Other amusement and recreation industries',
    description:
      'This industry group comprises establishments, not classified to any other industry group, primarily engaged in operating outdoor or indoor facilities, or providing services that enable patrons to participate in sports and recreational activities. Examples of establishments in this industry group are golf courses, skiing facilities, marinas, recreational, sports and fitness centres, and bowling centres.',
  },
  {
    code: '7211',
    title: 'Traveller accommodation',
    description:
      'This industry group comprises establishments primarily engaged in providing short-term lodging in facilities such as hotels, motor hotels, resorts, motels, casino hotels, bed and breakfast homes, and housekeeping cottages and cabins. These establishments may offer food and beverage services, recreational services, conference rooms and convention services, laundry services, parking and other services. All accommodation types may be booked via an online or platform-based reservation service. Classification of these units is determined by the type of accommodation offered and not by the type of booking system.',
  },
  {
    code: '7212',
    title: 'Recreational vehicle (RV) parks and recreational camps',
    description:
      'This industry group comprises establishments primarily engaged in operating recreational vehicle parks and campgrounds, hunting and fishing camps, and various types of vacation and adventure camps. These establishments cater to outdoor enthusiasts and are characterized by the type of accommodation and by the nature and the range of recreational facilities and activities provided to their clients.',
  },
  {
    code: '7213',
    title: 'Rooming and boarding houses',
    description:
      'This industry group comprises establishments primarily engaged in operating rooming and boarding houses and similar facilities. These establishments provide temporary or longer-term accommodation, which, for the period of occupancy, may serve as a principal residence. These establishments may also provide complementary services, such as housekeeping, meals and laundry services.',
  },
  {
    code: '7223',
    title: 'Special food services',
    description:
      "This industry group comprises establishments primarily engaged in providing food services at the customer's location, at a location designated by the customer, or from a motorized vehicle or non-motorized cart.",
  },
  {
    code: '7224',
    title: 'Drinking places (alcoholic beverages)',
    description:
      'This industry group comprises establishments, known as bars, taverns or drinking places, primarily engaged in preparing and serving alcoholic beverages for immediate consumption. These establishments may also provide limited food services.',
  },
  {
    code: '7225',
    title: 'Full-service restaurants and limited-service eating places',
    description:
      'This industry group comprises establishments primarily engaged in providing food services to patrons who order and are served while seated and pay after eating, or who order or select items at a counter, food bar or cafeteria line (or order by telephone) and pay before eating. This industry group includes drinking places that primarily serve food.',
  },
  {
    code: '8111',
    title: 'Automotive repair and maintenance',
    description:
      'This industry group comprises establishments primarily engaged in repairing and maintaining motor vehicles, such as cars, trucks, vans and commercial trailers.',
  },
  {
    code: '8112',
    title: 'Electronic and precision equipment repair and maintenance',
    description:
      'This industry group comprises establishments primarily engaged in repairing and maintaining electronic equipment and precision instruments.',
  },
  {
    code: '8113',
    title:
      'Commercial and industrial machinery and equipment (except automotive and electronic) repair and maintenance',
    description:
      'This industry group comprises establishments primarily engaged in repairing and maintaining commercial and industrial machinery and equipment, except automotive and electronic.',
  },
  {
    code: '8114',
    title: 'Personal and household goods repair and maintenance',
    description:
      'This industry group comprises establishments primarily engaged in repairing and maintaining personal and household goods, such as home and garden equipment, appliances, furniture, footwear and leather goods, garments, watches, jewellery, musical instruments, bicycles and recreational boats.',
  },
  {
    code: '8121',
    title: 'Personal care services',
    description:
      'This industry group comprises establishments primarily engaged in providing personal care services, such as hair care and esthetic services, hair replacement and scalp treatment services, massage services, diet counselling services and ear piercing services.',
  },
  {
    code: '8122',
    title: 'Funeral services',
    description:
      'This industry group comprises establishments primarily engaged in preparing the dead for burial or interment, conducting funerals, operating sites or structures reserved for the interment of human or animal remains, and cremating the dead. Examples of establishments in this industry group are funeral homes, cemeteries and crematoria.',
  },
  {
    code: '8123',
    title: 'Dry cleaning and laundry services',
    description:
      'This industry group comprises establishments primarily engaged in providing self-service laundry and dry-cleaning facilities for public use; providing dry-cleaning and laundering services; laundering and supplying laundered uniforms, linens and other fabric items; and providing other laundry services.',
  },
  {
    code: '8129',
    title: 'Other personal services',
    description:
      'This industry group comprises establishments, not classified to any other industry group, primarily engaged in providing personal services, such as pet care, photo finishing and parking services.',
  },
  {
    code: '8131',
    title: 'Religious organizations',
    description:
      'This industry group comprises establishments primarily engaged in operating religious organizations for religious worship, training or study; administering an organized religion; or promoting religious activities.',
  },
  {
    code: '8132',
    title: 'Grant-making and giving services',
    description:
      'This industry group comprises establishments primarily engaged in awarding grants from trust funds, or in soliciting contributions on behalf of others, to support a wide range of health, educational, scientific, cultural and other social welfare activities.',
  },
  {
    code: '8133',
    title: 'Social advocacy organizations',
    description:
      'This industry group comprises establishments primarily engaged in promoting a particular social or political cause intended to benefit a broad or specific constituency. Organizations of this type may also solicit contributions or sell memberships to support their activities.',
  },
  {
    code: '8134',
    title: 'Civic and social organizations',
    description:
      'This industry group comprises establishments primarily engaged in promoting the civic and social interests of their members. Establishments of this type may also operate bars and restaurants and provide other recreational services to members.',
  },
  {
    code: '8139',
    title: 'Business, professional, labour and other membership organizations',
    description:
      'This industry group comprises establishments, not classified to any other industry group, primarily engaged in promoting the interests of their members. Examples of establishments in this industry group are business associations, professional membership organizations, labour organizations and political organizations.',
  },
  {
    code: '8141',
    title: 'Private households',
    description:
      'This industry group comprises private households engaged in employing workers, on or about the premises, in activities primarily concerned with the operation of the household. These private households may employ individuals such as cooks, maids and butlers, and outside workers, such as gardeners, caretakers and other maintenance workers. The services of individuals providing baby-sitting or nanny services are included.',
  },
  {
    code: '9111',
    title: 'Defence services',
    description:
      'This industry group comprises establishments of the Canadian Armed Forces and civilian agencies primarily engaged in providing defence services.',
  },
  {
    code: '9112',
    title: 'Federal protective services',
    description:
      'This industry group comprises establishments of the federal government primarily engaged in providing services to ensure the security of persons and property. Protection includes measures to protect against negligence, exploitation and abuse.',
  },
  {
    code: '9113',
    title: 'Federal labour, employment and immigration services',
    description:
      'This industry group comprises establishments of the federal government primarily engaged in providing services for labour, employment, immigration, citizenship and other related fields.',
  },
  {
    code: '9114',
    title: 'Foreign affairs and international assistance',
    description:
      'This industry group comprises establishments of the federal government primarily engaged in promoting formal relations between the government of Canada and foreign countries.',
  },
  {
    code: '9119',
    title: 'Other federal government public administration',
    description:
      'This industry group comprises establishments of the federal government, not classified to any other industry group, primarily engaged in executive and legislative activities; fiscal and related policies and the administration of the public debt; assessing, levying and collecting taxes; conducting relations with other governments; and the administration of federal programs.',
  },
  {
    code: '9121',
    title: 'Provincial protective services',
    description:
      'This industry group comprises establishments of provincial and territorial governments primarily engaged in providing services to ensure the security of persons and property. Protection includes measures to protect against negligence, exploitation and abuse.',
  },
  {
    code: '9122',
    title: 'Provincial labour and employment services',
    description:
      'This industry group comprises establishments of provincial and territorial governments primarily engaged in labour market research and dealing in matters pertaining to employer-employee relations, including the promotion of improved working conditions and the provision of arbitration and conciliation services in collective bargaining.',
  },
  {
    code: '9129',
    title: 'Other provincial and territorial public administration',
    description:
      'This industry group comprises establishments of provincial and territorial governments, not classified to any other industry group, primarily engaged in executive and legislative activities; fiscal and related policies and the administration of the public debt; assessing, levying and collecting taxes; conducting relations with other governments; and the administration of provincial and territorial government programs.',
  },
  {
    code: '9131',
    title: 'Municipal protective services',
    description:
      'This industry group comprises establishments of local governments primarily engaged in providing services to ensure the security of persons and property. Protection includes measures to protect against negligence, exploitation and abuse.',
  },
  {
    code: '9139',
    title: 'Other local, municipal and regional public administration',
    description:
      'This industry group comprises establishments of local governments, not classified to any other industry group, primarily engaged in executive and legislative activities; planning, fiscal and related policies and the administration of the public debt; assessing, levying and collecting taxes; conducting relations with other governments; and the administration of local, municipal, and regional government programs.',
  },
  {
    code: '9141',
    title: 'Indigenous public administration',
    description:
      'This industry group comprises establishments of Indigenous governments primarily engaged in providing a wide variety of services to their citizens that would otherwise be provided by federal, provincial or municipal levels of governments.',
  },
  {
    code: '9191',
    title: 'International and other extra-territorial public administration',
    description:
      'This industry group comprises establishments of foreign governments in Canada primarily engaged in governmental service activities, such as consular, diplomatic and legation activities.',
  },
];
